



























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import EventsList from '@/components/EventsList.vue';
import HintsContainer from '@/components/HintsContainer.vue';
import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import SideToolbar from '@/components/SideToolbar.vue';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import AutoApprovalTab from '@/components/UI/AutoApprovalTab.vue';
import {TableHeaders} from '@/interfaces/components-data';
import {Hints, SelectBox, SelectKviCart, SelectMarket, TaskInfoCalc, WatchEventsType} from '@/interfaces/global-data';

import {
  AutoApprovalParams,
  CategoryStrategies,
  EventFilter,
  EventIndividualConfigs,
  EventsCalcParams,
  EventsProcessingStatus,
  GetTaskInfo,
  isInProgressStatus,
  LoadEventChangingType,
  LoadEventPeriods,
  LoadEventType,
  LoadEventTypeValues,
  ManuallyEventsWatchingParams,
  ProductTag,
  RequestEventList,
  ScheduleCalcColumns,
  SmallEventFilter,
  SmallEventFilterTree,
  TaskData,
  TaskInfoFilterType,
} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import Http from '@/mixins/http';
import {FormatNumber} from '@/numberFormatter';
import {BModal, BTabs} from 'bootstrap-vue';
import moment from 'moment';
import {Component, Mixins, Watch} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import * as _ from 'lodash';
import LocalData from '../mixins/local-data';
import Toast from '../mixins/toast';
import Card from '@/components/UI/Card.vue';
import CollapseCard from './UI/CollapseCard.vue';
import Tabs from '@/components/UI/Tabs.vue';
import FilterIcon from '@/components/UI/Table/FilterIcon.vue';
import SelectFilter from '@/components/UI/Table/SelectFilter.vue';
import KviCartSelect from "@/components/KviCartSelect.vue";
interface ICartEventsLevelFilterValues {
    format: number,
    region: number,
    clusters: number[],
    buyerSegmentsList: number[],
    seasonSelected: number[],
    separateClusters: boolean,
}

interface ICartEventsLevelFilterOptions {
    storeFormatOptions: Array<SelectBox<number>>,
    storeRegionOptions: Array<SelectBox<number>>,
    clusterOptions: Array<SelectBox<number>>,
    buyerSegmentOptions: Array<SelectBox<number>>,
}


// Interface for the event details form data
enum AutoApprovalValidationErrorType {
    MIN_VALUE_EXCEEDED = 'MIN_VALUE_EXCEEDED',
    MAX_VALUE_EXCEEDED = 'MAX_VALUE_EXCEEDED',
    RANGE_INVALID = 'RANGE_INVALID',
}

interface AutoApprovalValidationError {
    type: AutoApprovalValidationErrorType;
    message: string;
    relatedField?: string;
}

interface IEventDetailsFormData {
    groupsOfProduct: number[];
    categoriesOfProduct: number[];
    subcategories: number[];
    separateSubcategories: boolean;
    categoryStrategy: any;
    productSegments: number[];
    formatSelected: number[];
    regionSelected: number[];
    clusterSelected: number[];
    separateClusters: boolean;
    buyerSegmentsList: number[];
    seasonSelected: number[];
}

@Component({
    computed: {
        LoadEventPeriods() {
            return LoadEventPeriods
        },
        moment() {
            return moment
        },
    },
    components: {
        KviCartSelect,
        MarketSelect,
        MultiSelect,
        vSelect,
        DatePicker,
        SideToolbar,
        EventsList,
        HintsContainer,
        CollapseCard,
        Card,
        Tabs,
        FilterIcon,
        SelectFilter,
        SwitchWithLabel,
        AutoApprovalTab
    },
    filters: {
            formatDate: (v: any) => {
                if (v) {
                    return moment(new Date(+v)).format('YYYY-MM-DD');
                }
            },
        },
        methods: {
          getEventsProcessingStatusMessage(status: EventsProcessingStatus): string {
            const key = `events.processingStatus.${status}`;
            const translated = this.$t(key) as string;
            return translated === key ? '' : translated;
          },
            replaceTxtToNumber(value) {
                if (value == null) {
                    return null
                } else {
                    return value.replace(/[^\d]/g, '').substring(0, 2);
                }
            },
        },
    })
    export default class Events extends Mixins(LocalData, Toast, Http) {
        tabs: BTabs | null = null;
        defaultFilterValue = {value: -1, label: this.$t('shared.selectBox.all') as string};

        // Properties for event details modal
        eventDetailsModalVisible: boolean = false;
        selectedEvent: any = null;
        
        // Track if there are unsaved changes in the modal
        hasUnsavedModalChanges: boolean = false;
        isCheckingForUnsavedChanges: boolean = true;
        originalEventDetailsFormData: any = null;

        // Separate form data for the event details modal
        eventDetailsFormData: any = {
            groupsOfProduct: [],
            categoriesOfProduct: [],
            subcategories: [],
            separateSubcategories: false,
            categoryStrategy: CategoryStrategies.EMPTY,
            productSegments: [],
            formatSelected: [],
            regionSelected: [],
            clusterSelected: [],
            separateClusters: false,
            buyerSegmentsList: [],
            seasonSelected: []
        };

        // Using initializeEventDetailsFormData instead

        // Computed properties for event details form
        get isEventDetailsGroupsSelected(): boolean {
            const groups = LocalData.filterNumberArrays(this.eventDetailsFormData.groupsOfProduct);
            return groups != null && groups.length > 0;
        }
        get isEventDetailsCategoriesSelected(): boolean {
            const categories = LocalData.filterNumberArrays(this.eventDetailsFormData.categoriesOfProduct);
            return categories != null && categories.length > 0;
        }

        get isEventDetailsSubcategorySelected(): boolean {
            const subcategories = LocalData.filterNumberArrays(this.eventDetailsFormData.subcategories);
            return subcategories != null && subcategories.length > 0;
        }

        get isEventDetailsFormatSelected(): boolean {
            const formats = LocalData.filterNumberArrays(this.eventDetailsFormData.formatSelected);
            return formats != null && formats.length > 0;
        }

        get isEventDetailsRegionsSelected(): boolean {
            const regions = LocalData.filterNumberArrays(this.eventDetailsFormData.regionSelected);
            return regions != null && regions.length > 0;
        }

        get isEventDetailsClusterSelected(): boolean {
            const clusters = LocalData.filterNumberArrays(this.eventDetailsFormData.clusterSelected);
            return clusters != null && clusters.length > 0;
        }

    
        onEventDetailsFormDataChanged() {
            this.checkForUnsavedChanges();
        }

        // Event handler methods for form data updates
        updateEventDetailsProductGroup(groupsOfProduct: number[]) {
            this.onEventDetailsFormDataChanged();
            if (groupsOfProduct.length > 0 && !LocalData.compareTwoArrays(groupsOfProduct, this.eventDetailsFormData.groupsOfProduct)) {
                this.eventDetailsFormData.groupsOfProduct = groupsOfProduct;
                // Reset dependent fields since group has changed
                this.eventDetailsFormData.categoriesOfProduct = [];
                this.eventDetailsFormData.subcategories = [];
                // Update the category options based on the new group selection
                this.resetModalData(TaskInfoFilterType.group);
            }
        }


        updateEventDetailsProductCategory(categories: number[]) {
            this.onEventDetailsFormDataChanged();
            if (categories.length > 0 && !LocalData.compareTwoArrays(categories, this.eventDetailsFormData.categoriesOfProduct)) {
                this.eventDetailsFormData.categoriesOfProduct = categories;
                // Reset dependent fields
                this.eventDetailsFormData.subcategories = [];
                // Update subcategory options based on selected categories
                this.resetModalData(TaskInfoFilterType.category);
            }
        }

        updateEventDetailsSubcategories(subcategories: number[]) {
            this.onEventDetailsFormDataChanged();
            if (subcategories.length > 0 && !LocalData.compareTwoArrays(subcategories, this.eventDetailsFormData.subcategories)) {
                this.eventDetailsFormData.subcategories = subcategories;
                this.resetModalData(TaskInfoFilterType.subcategory);
            }
        }

        updateEventDetailsFormats(formats: number[]) {
            this.onEventDetailsFormDataChanged();
            if (formats.length > 0 && !LocalData.compareTwoArrays(formats, this.eventDetailsFormData.formatSelected)) {
                this.eventDetailsFormData.formatSelected = formats;
                // Reset dependent fields if necessary
                this.eventDetailsFormData.regionSelected = [];
                this.eventDetailsFormData.clusterSelected = [];
                this.resetModalData(TaskInfoFilterType.format);
            }
        }

        updateEventDetailsRegions(regions: number[]) {
            this.onEventDetailsFormDataChanged();
            if (regions.length > 0 && !LocalData.compareTwoArrays(regions, this.eventDetailsFormData.regionSelected)) {
                this.eventDetailsFormData.regionSelected = regions;
                // Reset dependent fields if necessary
                this.eventDetailsFormData.clusterSelected = [];
                this.resetModalData(TaskInfoFilterType.region);
                this.handleEventDetailsFormChange();
            }
        }

        updateEventDetailsClusters(clusters: number[]) {
            this.onEventDetailsFormDataChanged();
            if (clusters.length > 0 && !LocalData.compareTwoArrays(clusters, this.eventDetailsFormData.clusterSelected)) {
                this.eventDetailsFormData.clusterSelected = clusters;
                this.resetModalData(TaskInfoFilterType.cluster);
                this.handleEventDetailsFormChange();
            }
        }

        updateEventDetailsBuyerSegments(segments: number[]) {
            this.onEventDetailsFormDataChanged();
            if (segments.length > 0 && !LocalData.compareTwoArrays(segments, this.eventDetailsFormData.buyerSegmentsList)) {
                this.eventDetailsFormData.buyerSegmentsList = segments;
                this.handleEventDetailsFormChange();
            }
        }

        updateEventDetailsProductSegment(segments: number[]) {
            this.onEventDetailsFormDataChanged();
            if (segments.length > 0 && !LocalData.compareTwoArrays(segments, this.eventDetailsFormData.productSegments)) {
                this.eventDetailsFormData.productSegments = segments;
                this.handleEventDetailsFormChange();
            }
        }

        updateEventDetailsSeasons(seasons: number[]) {
            this.onEventDetailsFormDataChanged();
            if (seasons.length > 0 && !LocalData.compareTwoArrays(seasons, this.eventDetailsFormData.seasonSelected)) {
                this.eventDetailsFormData.seasonSelected = seasons;
                this.handleEventDetailsFormChange();
            }
        }

        // Toggle properties for event details modal
        toggleEventDetailsSeparateSubcategories() {
            this.onEventDetailsFormDataChanged();
            this.eventDetailsFormData.separateSubcategories = !this.eventDetailsFormData.separateSubcategories;
            this.handleEventDetailsFormChange();
        }

        toggleEventDetailsSeparateClusters() {
            this.onEventDetailsFormDataChanged();
            this.eventDetailsFormData.separateClusters = !this.eventDetailsFormData.separateClusters;
            this.handleEventDetailsFormChange();
        }

        // Method to initialize event details form data from an event
        // Using initializeEventDetailsFormData instead for consistency

        // Method to save event details form data back to the selected event
        saveEventDetailsFormData() {
            if (this.selectedEvent) {
                // Copy form data to the selected event
                this.selectedEvent.groupsOfProduct = [...this.eventDetailsFormData.groupsOfProduct];
                this.selectedEvent.categoriesOfProduct = [...this.eventDetailsFormData.categoriesOfProduct];
                this.selectedEvent.subcategories = [...this.eventDetailsFormData.subcategories];
                this.selectedEvent.separateSubcategories = this.eventDetailsFormData.separateSubcategories;
                this.selectedEvent.categoryStrategy = this.eventDetailsFormData.categoryStrategy;
                this.selectedEvent.productSegments = [...this.eventDetailsFormData.productSegments];
                this.selectedEvent.formatSelected = [...this.eventDetailsFormData.formatSelected];
                this.selectedEvent.regionSelected = [...this.eventDetailsFormData.regionSelected];
                this.selectedEvent.clusterSelected = [...this.eventDetailsFormData.clusterSelected];
                this.selectedEvent.separateClusters = this.eventDetailsFormData.separateClusters;
                this.selectedEvent.buyerSegmentsList = [...this.eventDetailsFormData.buyerSegmentsList];
                this.selectedEvent.seasonSelected = [...this.eventDetailsFormData.seasonSelected];

                // Reset change tracking since data is saved
                this.hasUnsavedModalChanges = false;
                this.originalEventDetailsFormData = _.cloneDeep(this.eventDetailsFormData);

                // Close the modal
                this.eventDetailsModalVisible = false;

                // Save the updated event data to the server if needed
                // this.saveEventToServer(this.selectedEvent);

                // Refresh the event list if needed
                // this.refreshEventList();
            }
        }

        openEventDetailsModal(event: any) {
            this.selectedEvent = event;
            this.initializeEventDetailsFormData(event);
            
            // Store a deep copy of the initial form data for change detection
            this.originalEventDetailsFormData = _.cloneDeep(this.eventDetailsFormData);
            this.hasUnsavedModalChanges = false;
            
            this.eventDetailsModalVisible = true;
        }

        closeEventDetailsModal() {
            // Check if there are unsaved changes
            if (this.hasUnsavedModalChanges) {
                // Show confirmation dialog
                this.$confirm({
                    title: this.$t('shared.messages.unsavedChanges') as string,
                    content: this.$t('events.modal.unsavedChangesText') as string,
                    okText: this.$t('shared.messages.yesClose') as string,
                    cancelText: this.$t('shared.actions.cancel') as string,
                    onOk: () => {
                        this.forceCloseModal();
                        this.originalEventDetailsFormData = null;
                        this.isCheckingForUnsavedChanges = false;
                    },
                    onCancel: () => {
                        // Do nothing, keep modal open
                    }
                });
            } else {
                this.forceCloseModal();
            }
        }

        forceCloseModal() {
            this.eventDetailsModalVisible = false;
            this.selectedEvent = null;
            this.hasUnsavedModalChanges = false;
            this.isCheckingForUnsavedChanges = false;
            this.originalEventDetailsFormData = null;
        }

        currentTab: string = "categoriesEvents"
        aTabs = [
          {
            label: this.$t('events.tabs.categoryEvents') as string,
            value: 'categoriesEvents'
          },
          {
            label: this.$t('events.tabs.cartEvents') as string,
            value: 'cartsEvents'
          },
          {
            label: this.$t('events.tabs.eventsList') as string,
            value: 'listOfEvents'
          }
        ];

        selectTradingFilter: SelectBox<number> = this.defaultFilterValue;
        newSelectTradingFilter: number = this.defaultFilterValue.value;
        traidingsFilterOptions: Array<SelectBox<number>> = [];

        selectCategoryFilter: SelectBox<number> = this.defaultFilterValue;
        newSelectCategoryFilter: number = this.defaultFilterValue.value;
        categoryFilterOptions: Array<SelectBox<number>> = [];

        selectGroupFilter: SelectBox<number> = this.defaultFilterValue;
        newSelectGroupFilter: number = this.defaultFilterValue.value;
        groupFilterOptions: Array<SelectBox<number>> = [];

        selectSubcategoryFilter: SelectBox<number> = this.defaultFilterValue;
        newSelectSubcategoryFilter: number = this.defaultFilterValue.value;
        subcategoryFilterOptions: Array<SelectBox<number>> = [];

        selectFormatFilter: SelectBox<number> = this.defaultFilterValue;
        newSelectFormatFilter: number = this.defaultFilterValue.value;
        formatFilterOptions: Array<SelectBox<number>> = [];

        selectRegionFilter: SelectBox<number> = this.defaultFilterValue;
        newSelectRegionFilter: number = this.defaultFilterValue.value;
        regionFilterOptions: Array<SelectBox<number>> = [];

        selectClusterFilter: SelectBox<number> = this.defaultFilterValue;
        newSelectClusterFilter: number = this.defaultFilterValue.value;
        clusterFilterOptions: Array<SelectBox<number>> = [];

        kviCartNameFilter: SelectBox<number> = this.defaultFilterValue;
        newKviCartNameFilter: number = this.defaultFilterValue.value;
        kviCartNameOptions: Array<SelectBox<number>> = [];

        eventPeriodicityOpts = [
            { value: LoadEventPeriods.DAY, label: this.$t('events.periodicity.DAY') as string },
            { value: LoadEventPeriods.MONTH, label: this.$t('events.periodicity.MONTH') as string },
            { value: LoadEventPeriods.WEEK, label: this.$t('events.periodicity.WEEK') as string },
        ];
        eventTypeOpts = [
            { value: LoadEventTypeValues.CHANGING_PURCHASE_PRICE, label: this.$t('events.types.CHANGING_PURCHASE_PRICE') as string },
            { value: LoadEventTypeValues.CHANGING_COMPETITORS_PRICE, label: this.$t('events.types.CHANGING_COMPETITORS_PRICE') as string },
            { value: LoadEventTypeValues.CHANGING_MRP, label: this.$t('events.types.CHANGING_MRP') as string },
            { value: LoadEventTypeValues.ADDING_NEW_PRODUCT, label: this.$t('events.types.ADDING_NEW_PRODUCT') as string },
            { value: LoadEventTypeValues.CHANGING_LINES, label: this.$t('events.types.CHANGING_LINES') as string },
        ];
        eventChangingTypeOpts = [
            { value: LoadEventChangingType.BOTH, label: this.$t('events.changingTypes.BOTH') as string },
            { value: LoadEventChangingType.DECREASE, label: this.$t('events.changingTypes.DECREASE') as string },
            { value: LoadEventChangingType.INCREASE, label: this.$t('events.changingTypes.INCREASE') as string },
        ];

        defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('shared.selectBox.all') as string}];
        taskInfo: TaskInfoCalc = {
            storeFormatOptions: [],
            storeRegionOptions: [],
            buyerSegmentOptions: [],
            categoryOptions: [],
            clusterOptions: [],
            groupsOfProduct: [],
            subcategories: [],
            subcategoriesDefault: [],
            psegemnts: [],
        };
        modalTaskInfo: TaskInfoCalc = {
            storeFormatOptions: [],
            storeRegionOptions: [],
            buyerSegmentOptions: [],
            categoryOptions: [],
            clusterOptions: [],
            groupsOfProduct: [],
            subcategories: [],
            subcategoriesDefault: [],
            psegemnts: [],
        };

        cartEventsLevelFilterValues: ICartEventsLevelFilterValues = {
            format: 0,
            region: 0,
            clusters: [],
            buyerSegmentsList: [],
            seasonSelected: [],
            separateClusters: false,
        };

        cartEventsLevelFilterOptions: ICartEventsLevelFilterOptions = {
            storeFormatOptions: [{value: 0, label: this.$t('shared.selectBox.all') as string}],
            storeRegionOptions: [{value: 0, label: this.$t('shared.selectBox.all') as string}],
            clusterOptions: [{value: 0, label: this.$t('shared.selectBox.all') as string}],
            buyerSegmentOptions: [{value: 0, label: this.$t('shared.selectBox.all') as string}],
        };

        errors = [];
        tableKey = 1;
        kviCarts: SelectKviCart[] = [];
        kviCartComponentKey = 1
        searchable: boolean = true;
        selectPeriodicityOptions: SelectBox<LoadEventPeriods> = {value: LoadEventPeriods.DAY, label: this.$t('events.periodicity.DAY') as string};
        selectTypeOptions: SelectBox<LoadEventType> = {
            value: LoadEventTypeValues.CHANGING_PURCHASE_PRICE,
            label: this.$t('events.types.CHANGING_PURCHASE_PRICE') as string,
        };
        changingType: SelectBox<LoadEventChangingType> = {value: LoadEventChangingType.INCREASE, label: this.$t('events.changingTypes.INCREASE') as string};

        eventTableRows: SmallEventFilter[] = [];
        autoApprovalErrors: { [eventId: number]: { [fieldName: string]: AutoApprovalValidationError } } = {};
        totalElements: number = 0
        tableIsLoading: boolean = false
        isCreatingEvent: boolean = false
        deletingEventId: number | null = null
        savingEventId: number | null = null

        delta: number | undefined = 0.00;

        localSelectKviCart: SelectKviCart = {id: -1, kviCartName: this.$t('shared.selectBox.selectOption') as string}

        eventTableFields: TableHeaders[] = [
            {key: 'options', label: this.$t('shared.labels.actions') as string},
            {key: 'startDate', label: this.$t('shared.labels.startDate') as string},
            {key: 'endDate', label: this.$t('shared.labels.endDate') as string},
            {key: 'periodicity', label: this.$t('shared.labels.periodicity') as string},
            {key: 'type.label', label: this.$t('shared.labels.type') as string},
            {key: 'delta', label: this.$t('shared.labels.deviationPercent') as string},
            {key: 'changingType', label: this.$t('shared.labels.change') as string},
            {key: 'startCalculation', label: this.$t('shared.labels.recalculation') as string},
            {key: 'onlyChangedPrices', label: this.$t('shared.labels.changedPrices') as string},
            {key: 'deployPrices', label: this.$t('shared.labels.deploy') as string},
            {key: 'createCommonReport', label: this.$t('shared.labels.common') as string},
            {key: 'timeout', label: this.$t('shared.labels.timeout') as string},
            {key: 'priority', label: this.$t('shared.labels.priority') as string},
            {key: 'tradingName', label: this.$t('shared.labels.company') as string},
            {key: 'groupsOfProduct', label: this.$t('shared.labels.group') as string},
            {key: 'categories', label: this.$t('shared.labels.category') as string},
            {key: 'subcategories', label: this.$t('shared.labels.subcategories') as string},
            {key: 'storeFormat', label: this.$t('shared.labels.storeFormat') as string},
            {key: 'storeRegions', label: this.$t('shared.labels.region') as string},
            {key: 'storeCluster', label: this.$t('shared.labels.cluster') as string},
        ];

        allRowsSelected: boolean = false;
        included: number[] = [];
        excluded: number[] = [];

        resetEventsSelectedData() {
          this.allRowsSelected = false
          this.included = []
          this.excluded = []
        }

        newEventTableFields: any[] = [
            {dataIndex: 'selected', scopedSlots: { customRender: 'selected', title: 'selectedTitle' }, fixed: 'left', width: 50},
            {dataIndex: 'options', title: this.$t('shared.labels.actions') as string, scopedSlots: { customRender: 'options' }, fixed: 'left', width: 130},
            {dataIndex: 'startDate', title: this.$t('shared.labels.startDate') as string, scopedSlots: { customRender: 'startDate' }, width: 150},
            {dataIndex: 'endDate', title: this.$t('shared.labels.endDate') as string, scopedSlots: { customRender: 'endDate' }, width: 150},
            {dataIndex: 'periodicity', title: this.$t('shared.labels.periodicity') as string, width: 150, scopedSlots: { customRender: 'periodicity' }},
            {dataIndex: 'type', title: this.$t('shared.labels.type') as string, width: 200, scopedSlots: { customRender: 'type' }},
            {dataIndex: 'delta', title: this.$t('shared.labels.deviationPercent') as string, scopedSlots: { customRender: 'delta' }, width: 150},
            {
                dataIndex: 'useAutoApproval',
                title: this.$t('events.table.useAutoApproval') as string,
                scopedSlots: {customRender: 'useAutoApproval'},
                width: 220
            },
            {
                dataIndex: 'priceChangeFrom',
                title: this.$t('events.table.priceChangeFrom') as string,
                scopedSlots: {customRender: 'priceChangeFrom'},
                width: 150
            },
            {
                dataIndex: 'priceChangeTo',
                title: this.$t('events.table.priceChangeTo') as string,
                scopedSlots: {customRender: 'priceChangeTo'},
                width: 150
            },
            {
                dataIndex: 'marginChangeFrom',
                title: this.$t('events.table.marginChangeFrom') as string,
                scopedSlots: {customRender: 'marginChangeFrom'},
                width: 150
            },
            {
                dataIndex: 'marginChangeTo',
                title: this.$t('events.table.marginChangeTo') as string,
                scopedSlots: {customRender: 'marginChangeTo'},
                width: 150
            },
            {
                dataIndex: 'profitabilityFrom',
                title: this.$t('events.table.profitabilityFrom') as string,
                scopedSlots: {customRender: 'profitabilityFrom'},
                width: 200
            },
            {
                dataIndex: 'profitabilityTo',
                title: this.$t('events.table.profitabilityTo') as string,
                scopedSlots: {customRender: 'profitabilityTo'},
                width: 200
            },
            {dataIndex: 'piFrom', title: this.$t('events.table.piFrom') as string, scopedSlots: {customRender: 'piFrom'}, width: 150},
            {dataIndex: 'piTo', title: this.$t('events.table.piTo') as string, scopedSlots: {customRender: 'piTo'}, width: 150},
            {
                dataIndex: 'revaluationEfficiencyCheck',
                title: this.$t('events.table.revaluationEfficiencyCheck') as string,
                scopedSlots: {customRender: 'revaluationEfficiencyCheck'},
                width: 250
            },
            {dataIndex: 'changingType', title: this.$t('shared.labels.change') as string, width: 200, scopedSlots: { customRender: 'changingType' }},
            {dataIndex: 'applyOmnichannel', title: this.$t('shared.labels.omnichannel') as string, width: 200, scopedSlots: { customRender: 'applyOmnichannel' }},
            {dataIndex: 'startCalculation', title: this.$t('shared.labels.recalculation') as string, scopedSlots: { customRender: 'startCalculation' }, width: 110},
            {dataIndex: 'onlyChangedPrices', title: this.$t('shared.labels.changedPrices') as string, scopedSlots: { customRender: 'onlyChangedPrices' }, width: 120},
            {dataIndex: 'deployPrices', title: this.$t('shared.labels.deploy') as string, scopedSlots: { customRender: 'deployPrices' }, width: 110},
            {dataIndex: 'createCommonReport', title: this.$t('shared.labels.common') as string, scopedSlots: { customRender: 'createCommonReport' }, width: 100},
            {dataIndex: 'timeout', title: this.$t('shared.labels.timeout') as string, scopedSlots: { customRender: 'timeout' }, width: 150},
            {dataIndex: 'priority', title: this.$t('shared.labels.priority') as string, scopedSlots: { customRender: 'priority' }, width: 150},
            {dataIndex: 'tradingName', title: this.$t('shared.labels.company') as string, width: 150, filters: [], scopedSlots: { filterDropdown: 'tradingNameFilter', filterIcon: "tradingNameFilterIcon" }, ellipsis: true},
            {dataIndex: 'groupsOfProduct', title: this.$t('shared.labels.group') as string, width: 200, filters: [], scopedSlots: { filterDropdown: 'groupsOfProductFilter', filterIcon: "groupsOfProductFilterIcon" }, ellipsis: true},
            {dataIndex: 'categories', title: this.$t('shared.labels.category') as string, width: 200, filters: [], scopedSlots: { filterDropdown: 'categoriesFilter', filterIcon: "categoriesFilterIcon" }, ellipsis: true},
            {dataIndex: 'subcategories', title: this.$t('shared.labels.subcategories') as string, width: 200, filters: [], scopedSlots: { filterDropdown: 'subcategoriesFilter', filterIcon: "subcategoriesFilterIcon" }, ellipsis: true},
            {dataIndex: 'storeFormat', title: this.$t('shared.labels.storeFormat') as string, width: 150, filters: [], scopedSlots: { filterDropdown: 'storeFormatFilter', filterIcon: "storeFormatFilterIcon" }, ellipsis: true},
            {dataIndex: 'storeRegions', title: this.$t('shared.labels.region') as string, width: 150, filters: [], scopedSlots: { filterDropdown: 'storeRegionsFilter', filterIcon: "storeRegionsFilterIcon" }, ellipsis: true},
            {dataIndex: 'storeCluster', title: this.$t('shared.labels.cluster') as string, width: 150, filters: [], scopedSlots: { filterDropdown: 'storeClusterFilter', filterIcon: "storeClusterFilterIcon" }, ellipsis: true},
        ];

    cartEventsTableFields: any[] = [
        {dataIndex: 'selected', scopedSlots: { customRender: 'selected', title: 'selectedTitle' }, fixed: 'left', width: 50},
        {dataIndex: 'options', title: this.$t('shared.labels.actions') as string, scopedSlots: { customRender: 'options' }, fixed: 'left', width: 130},
        {dataIndex: 'startDate', title: this.$t('shared.labels.startDate') as string, scopedSlots: { customRender: 'startDate' }, width: 150},
        {dataIndex: 'endDate', title: this.$t('shared.labels.endDate') as string, scopedSlots: { customRender: 'endDate' }, width: 150},
        {dataIndex: 'periodicity', title: this.$t('shared.labels.periodicity') as string, width: 150, scopedSlots: { customRender: 'periodicity' }},
        {dataIndex: 'type', title: this.$t('shared.labels.type') as string, width: 200, scopedSlots: { customRender: 'type' }},
        {dataIndex: 'delta', title: this.$t('shared.labels.deviationPercent') as string, scopedSlots: { customRender: 'delta' }, width: 150},
        {
            dataIndex: 'useAutoApproval',
            title: this.$t('events.table.useAutoApproval') as string,
            scopedSlots: {customRender: 'useAutoApproval'},
            width: 220
        },
        {
            dataIndex: 'priceChangeFrom',
            title: this.$t('events.table.priceChangeFrom') as string,
            scopedSlots: {customRender: 'priceChangeFrom'},
            width: 150
        },
        {
            dataIndex: 'priceChangeTo',
            title: this.$t('events.table.priceChangeTo') as string,
            scopedSlots: {customRender: 'priceChangeTo'},
            width: 150
        },
        {
            dataIndex: 'marginChangeFrom',
            title: this.$t('events.table.marginChangeFrom') as string,
            scopedSlots: {customRender: 'marginChangeFrom'},
            width: 150
        },
        {
            dataIndex: 'marginChangeTo',
            title: this.$t('events.table.marginChangeTo') as string,
            scopedSlots: {customRender: 'marginChangeTo'},
            width: 150
        },
        {
            dataIndex: 'profitabilityFrom',
            title: this.$t('events.table.profitabilityFrom') as string,
            scopedSlots: {customRender: 'profitabilityFrom'},
            width: 200
        },
        {
            dataIndex: 'profitabilityTo',
            title: this.$t('events.table.profitabilityTo') as string,
            scopedSlots: {customRender: 'profitabilityTo'},
            width: 200
        },
        {dataIndex: 'piFrom', title: this.$t('events.table.piFrom') as string, scopedSlots: {customRender: 'piFrom'}, width: 150},
        {dataIndex: 'piTo', title: this.$t('events.table.piTo') as string, scopedSlots: {customRender: 'piTo'}, width: 150},
        {
            dataIndex: 'revaluationEfficiencyCheck',
            title: this.$t('events.table.revaluationEfficiencyCheck') as string,
            scopedSlots: {customRender: 'revaluationEfficiencyCheck'},
            width: 250
        },
        {dataIndex: 'changingType', title: this.$t('shared.labels.change') as string, width: 200, scopedSlots: { customRender: 'changingType' }},
        {dataIndex: 'applyOmnichannel', title: this.$t('shared.labels.omnichannel') as string, width: 200, scopedSlots: { customRender: 'applyOmnichannel' }},
        {dataIndex: 'startCalculation', title: this.$t('shared.labels.recalculation') as string, scopedSlots: { customRender: 'startCalculation' }, width: 110},
        {dataIndex: 'onlyChangedPrices', title: this.$t('shared.labels.changedPrices') as string, scopedSlots: { customRender: 'onlyChangedPrices' }, width: 120},
        {dataIndex: 'deployPrices', title: this.$t('shared.labels.deploy') as string, scopedSlots: { customRender: 'deployPrices' }, width: 110},
        {dataIndex: 'createCommonReport', title: this.$t('shared.labels.common') as string, scopedSlots: { customRender: 'createCommonReport' }, width: 100},
        {dataIndex: 'timeout', title: this.$t('shared.labels.timeout') as string, scopedSlots: { customRender: 'timeout' }, width: 150},
        {dataIndex: 'priority', title: this.$t('shared.labels.priority') as string, scopedSlots: { customRender: 'priority' }, width: 150},
        {dataIndex: 'tradingName', title: this.$t('shared.labels.company') as string, width: 150, filters: [], scopedSlots: { filterDropdown: 'tradingNameFilter', filterIcon: "tradingNameFilterIcon" }, ellipsis: true},
        {dataIndex: 'storeFormat', title: this.$t('shared.labels.storeFormat') as string, width: 150, filters: [], scopedSlots: { filterDropdown: 'storeFormatFilter', filterIcon: "storeFormatFilterIcon" }, ellipsis: true},
        {dataIndex: 'storeRegions', title: this.$t('shared.labels.region') as string, width: 150, filters: [], scopedSlots: { filterDropdown: 'storeRegionsFilter', filterIcon: "storeRegionsFilterIcon" }, ellipsis: true},
        {dataIndex: 'storeCluster', title: this.$t('shared.labels.cluster') as string, width: 150, filters: [], scopedSlots: { filterDropdown: 'storeClusterFilter', filterIcon: "storeClusterFilterIcon" }, ellipsis: true},
        {dataIndex: 'kviCartName', title: this.$t('shared.labels.kviCart') as string, width: 150, filters: [], scopedSlots: { filterDropdown: 'kviCartNameFilter', filterIcon: "kviCartNameFilterIcon" }, ellipsis: true},
    ];

        pagination: any = {
            pageSize: 20,
        };

        startingWatchEvents: boolean = false;
        startingWatchEventsKvi: boolean = false;
        eventsWatchingStatus: EventsProcessingStatus = EventsProcessingStatus.DONE;
        eventsWatchingPreviousStatus: EventsProcessingStatus = EventsProcessingStatus.DONE;
        isEventsWatchingStatusInProgress: boolean = false;
        intervalId: number | null = null;
        startIntervalForFetchingEventsWatchingStatus() {
          // Очистка предыдущего таймера, если он существует
          if (this.intervalId) {
            clearInterval(this.intervalId)
          }

          // Установка нового таймера
          this.intervalId = setInterval(this.getEventsWatchingEventsStatus, 10_000);
          this.getEventsWatchingEventsStatus(); // Немедленный вызов при изменении
        }


        paramsRulesKey: number = 1;
        eventPerPage: number = 20;
        eventCurrentPage: number = 1;
        eventTotalRows: number = 0;
        showBookmarks: boolean = true;
        showMainFilters: boolean = true;
        hints: Hints[] = [];
        private responseIds: number[] = [];
        private responseId: number = -1;
        private needLoadFiltersForTable: boolean = true;
        private eventCalcId: number = -1;
        private startDate: string = '';
        private endDate: string = '';
        private eventCalcLimit: number = 20;
        private refreshEventListId = -1;
    private dropDownOpen = false;
    // tslint:disable-next-line: ban-types
    private onDropdownClosed: Function | null = null;

        selectEventType() {
          if (this.selectTypeOptions.value == LoadEventTypeValues.CHANGING_MRP
              || this.selectTypeOptions.value == LoadEventTypeValues.ADDING_NEW_PRODUCT
              || this.selectTypeOptions.value == LoadEventTypeValues.CHANGING_LINES
          ) {
            this.delta = 0
            this.changingType = { value: LoadEventChangingType.BOTH, label: this.$t('events.changingTypes.BOTH') as string }
          }
        }

        disableSpecialEventParams(): boolean {
          return this.selectTypeOptions.value == LoadEventTypeValues.CHANGING_MRP
              || this.selectTypeOptions.value == LoadEventTypeValues.ADDING_NEW_PRODUCT
              || this.selectTypeOptions.value == LoadEventTypeValues.CHANGING_LINES
        }


        isSelectedEventId(eventId: number): boolean {
          if (this.allRowsSelected) {
            return !this.excluded.includes(eventId);
          } else {
            return this.included.includes(eventId);
          }
        }

        setSelectedEventId(eventId: number, checked: boolean) {
            if (this.allRowsSelected) {
                if (checked) {
                    // Удаляем из excluded
                    this.excluded = this.excluded.filter(id => id !== eventId);
                } else {
                    // Добавляем в excluded, если ещё нет
                    if (!this.excluded.includes(eventId)) {
                        this.excluded.push(eventId);
                    }
                }
            } else {
                if (checked) {
                    // Добавляем в included, если ещё нет
                    if (!this.included.includes(eventId)) {
                        this.included.push(eventId);
                    }
                } else {
                    // Удаляем из included
                    this.included = this.included.filter(id => id !== eventId);
                }
            }

            if (this.allRowsSelected) {
              // Если вручную выключили все позиции, то выключаем общий чек-бокс
              if (this.excluded.length == this.totalElements) this.selectOrClearAllEvents(false)
            } else {
              // Если вручную включили все позиции, то включаем общий чек-бокс
              if (this.included.length == this.totalElements) this.selectOrClearAllEvents(true)
            }
        }

        selectOrClearAllEvents(checked: boolean) {
          this.allRowsSelected = checked
          this.included = []
          this.excluded = []
        }

        anyEventsSelected(): boolean {
          return this.allRowsSelected || this.included.length > 0
        }

        getCalcParams() {
            const params = this.getEventsCalcParams()
            this.$log.info(params)
            this.httpFetchEventsCalcParams(params)
                    .then((r) => {
                        const data = r.data
                        this.$events.timeout = data.timeout
                        this.$events.priority = data.priority
                        this.$log.info(data)
                    })
                    .catch((e) => {
                        this.showError(this.$t('events.messages.errorLoadParams') as string);
                    })
        }

        saveCalcParams() {
            const params = {
                tradingId: this.$events.selectMarket.id,
                categories: LocalData.filterNumberArrays(this.$events.categoriesOfProduct),
            productSegments: LocalData.filterNumberArrays(this.$events.productSegments),
                groupsOfProduct: this.$events.groupsOfProduct,
                subcategories: this.$events.subcategories,
                storeFormat: this.$events.formatSelected,
                storeRegionValues: this.$events.regionSelected,
                storeCluster: this.$events.clusterSelected,
                categoryStrategy: this.$events.categoryStrategy.value,
                separateSubcategories: this.$events.separateSubcategories,
                separateClusters: this.$events.separateClusters,
                storeSegment: this.$events.buyerSegmentsList,
                timeout: this.$events.timeout,
                priority: this.$events.priority,
                autoApprovalParams: this.$events.autoApprovalParams && this.$events.autoApprovalParams.useAutoApproval ? this.$events.autoApprovalParams : undefined,
            }
            this.httpSaveEventsCalcParams(params)
                    .then((r) => {
                        this.showInfo(this.$t('events.messages.paramsSuccess') as string);
                        const data = r.data
                        this.$events.timeout = data.timeout
                        this.$events.priority = data.priority
                        this.$log.info(data)
                    })
                    .catch((e) => {
                        this.showError(this.$t('events.messages.errorSaveParams') as string);
                    })
        }

        getEventsCalcParams(): EventsCalcParams {
            return {
                tradingId: this.$events.selectMarket.id,
                categories: LocalData.filterNumberArrays(this.$events.categoriesOfProduct),
            productSegments: LocalData.filterNumberArrays(this.$events.productSegments),
                groupsOfProduct: this.$events.groupsOfProduct,
                subcategories: this.$events.subcategories,
                storeFormat: this.$events.formatSelected,
                storeRegionValues: this.$events.regionSelected,
                storeCluster: this.$events.clusterSelected,
                categoryStrategy: this.$events.categoryStrategy.value,
                separateSubcategories: this.$events.separateSubcategories,
                separateClusters: this.$events.separateClusters,
                storeSegment: this.$events.buyerSegmentsList,
                autoApprovalParams: this.$events.autoApprovalParams && this.$events.autoApprovalParams.useAutoApproval ? this.$events.autoApprovalParams : undefined,
            }
        }

        updateKviCart(cart: SelectKviCart) {
            this.$events.selectKviCart = cart;
            this.saveEvents();
        }

        onMainTabsChanged(key:any) {
            if (key === 'listOfEvents') {
                this.currentTab = 'listOfEvents'
                this.$refs.eventsListRef && (this.$refs.eventsListRef as EventsList).load();
            } else if (key === 'categoriesEvents') {
                this.currentTab = 'categoriesEvents'
                this.onEventTableChange({
                    pageSize: 50,
                    current: 1,
                })
            } else if (key === 'cartsEvents') {
                this.currentTab = 'cartsEvents'
                this.onCartsEventTableChange({
                    pageSize: 50,
                    current: 1,
                })

                this.$nextTick(() => {
                    this.fetchCartEventsFormatOptions();
                })
            }
        }

        changeField (e: any, id: any, type: string) {
            // @ts-ignore
            if (type === 'periodicity') this.eventTableRows.find(e => e.id === id).periodicity = { label: this.eventPeriodicityOpts.find(i => i.value === e).label, value: e };
            // @ts-ignore
            else this.eventTableRows.find(e => e.id === id).changingType = { label: this.eventChangingTypeOpts.find(i => i.value === e).label, value: e }
        }

    setAutoApprovalParam(
        eventId: number,
        fieldName: keyof AutoApprovalParams,
        value: any,
        options?: {
            validateRelatedField?: string;
        }
    ) {
            const eventRow = this.eventTableRows.find((e) => e.id === eventId);

            if (!eventRow) return;

            if (!eventRow.autoApprovalParams) {
            this.$set(eventRow, 'autoApprovalParams', {
                [fieldName]: value
            } as any);
        } else {
            this.$set(eventRow.autoApprovalParams, fieldName, value);
        }

        if (this.shouldValidateField(fieldName)) {
            this.validateAutoApprovalField(eventId, fieldName);
        }

        if (options && options.validateRelatedField) {
            this.validateAutoApprovalField(eventId, options.validateRelatedField);
        }
    }

    private shouldValidateField(fieldName: keyof AutoApprovalParams): boolean {
        return fieldName !== 'useAutoApproval';
    }

    handleUseAutoApprovalChange(eventId: number, value: boolean) {
        const eventRow = this.eventTableRows.find((e) => e.id === eventId);

        if (!eventRow) return;

        if (!value) {
            if (this.autoApprovalErrors[eventId]) {
                this.$delete(this.autoApprovalErrors, eventId);
            }

            this.$set(eventRow, 'autoApprovalParams', {
                useAutoApproval: false,
                revaluationEfficiencyCheck: false
            });
        } else {
            this.setAutoApprovalParam(eventId, 'useAutoApproval', value);
        }
    }


    getAutoApprovalFieldError(eventId: number, fieldName: string): string | undefined {
        const error = this.autoApprovalErrors[eventId] && this.autoApprovalErrors[eventId][fieldName];
        return error ? error.message : undefined;
    }

    private isRangeError(error: AutoApprovalValidationError | undefined): boolean {
        return error !== undefined && error.type === AutoApprovalValidationErrorType.RANGE_INVALID;
    }

    private clearRelatedFieldError(eventId: number, relatedField: string | undefined) {
        if (relatedField && this.autoApprovalErrors[eventId] && this.autoApprovalErrors[eventId][relatedField]) {
            const relatedError = this.autoApprovalErrors[eventId][relatedField];

            if (this.isRangeError(relatedError)) {
                this.$delete(this.autoApprovalErrors[eventId], relatedField);
            }
        }
    }

    getAutoApprovalFieldStatus(eventId: number, fieldName: string): 'error' | undefined {
        return this.getAutoApprovalFieldError(eventId, fieldName) ? 'error' : undefined;
    }

    hasAutoApprovalValidationErrors(eventId: number): boolean {
        return this.autoApprovalErrors[eventId] !== undefined &&
            Object.keys(this.autoApprovalErrors[eventId]).length > 0;
    }

    getAutoApprovalValidationErrorsMessage(eventId: number): string {
        if (!this.hasAutoApprovalValidationErrors(eventId)) {
            return '';
        }

        const errors = this.autoApprovalErrors[eventId];
        const errorMessages = Object.values(errors)
            .map(error => error.message)
            .filter((msg, index, self) => self.indexOf(msg) === index);

        return (this.$t('events.validation.validationErrors') as string) + errorMessages.join('; ');
    }

    private isEmptyValue(value: any): value is undefined | null | '' {
        return value === undefined || value === null || value === '';
    }

    validateAutoApprovalField(eventId: number, fieldName: string) {
        const event = this.eventTableRows.find(e => e.id === eventId);

        if (!event || !event.autoApprovalParams) {
            if (this.autoApprovalErrors[eventId]) {
                this.$delete(this.autoApprovalErrors[eventId], fieldName);
            }

            return;
        }

        const params = event.autoApprovalParams;

        if (!this.autoApprovalErrors[eventId]) {
            this.$set(this.autoApprovalErrors, eventId, {});
        }

        if (this.autoApprovalErrors[eventId] && this.autoApprovalErrors[eventId][fieldName]) {
            this.$delete(this.autoApprovalErrors[eventId], fieldName);
        }

        let hasError = false;

            switch (fieldName) {
                case 'priceChangeFrom':
                if (!this.isEmptyValue(params.priceChangeFrom)) {
                    const fromValue = params.priceChangeFrom as number;

                    if (fromValue < -100) {
                        this.$set(this.autoApprovalErrors[eventId], 'priceChangeFrom', {
                            type: AutoApprovalValidationErrorType.MIN_VALUE_EXCEEDED,
                            message: this.$t('events.validation.priceLowerBoundMin') as string
                        });

                        hasError = true;
                    }
                }

                if (this.isEmptyValue(params.priceChangeFrom)) {
                    this.clearRelatedFieldError(eventId, 'priceChangeTo');
                }

                if (!hasError && !this.isEmptyValue(params.priceChangeFrom) && !this.isEmptyValue(params.priceChangeTo)) {
                    const fromValue = params.priceChangeFrom as number;
                    const toValue = params.priceChangeTo as number;

                    if (fromValue > toValue) {
                        this.$set(this.autoApprovalErrors[eventId], 'priceChangeFrom', {
                            type: AutoApprovalValidationErrorType.RANGE_INVALID,
                            message: this.$t('events.validation.lowerBoundExceedsUpper') as string,
                            relatedField: 'priceChangeTo'
                        });

                        hasError = true;
                    }
                }

                if (!hasError || this.isEmptyValue(params.priceChangeFrom) || this.isEmptyValue(params.priceChangeTo)) {
                    this.clearRelatedFieldError(eventId, 'priceChangeTo');
                }

                break;

            case 'priceChangeTo':
                hasError = false;

                if (!this.isEmptyValue(params.priceChangeTo)) {
                    const toValue = params.priceChangeTo as number;

                    if (toValue < -100) {
                        this.$set(this.autoApprovalErrors[eventId], 'priceChangeTo', {
                            type: AutoApprovalValidationErrorType.MIN_VALUE_EXCEEDED,
                            message: this.$t('events.validation.priceUpperBoundMin') as string
                        });

                        hasError = true;
                    }
                }
                if (this.isEmptyValue(params.priceChangeTo)) {
                    this.clearRelatedFieldError(eventId, 'priceChangeFrom');
                }

                if (!hasError && !this.isEmptyValue(params.priceChangeFrom) && !this.isEmptyValue(params.priceChangeTo)) {
                    const fromValue = params.priceChangeFrom as number;
                    const toValue = params.priceChangeTo as number;

                    if (fromValue > toValue) {
                        this.$set(this.autoApprovalErrors[eventId], 'priceChangeTo', {
                            type: AutoApprovalValidationErrorType.RANGE_INVALID,
                            message: this.$t('events.validation.upperBoundBelowLower') as string,
                            relatedField: 'priceChangeFrom'
                        });

                        hasError = true;
                    }
                }

                if (!hasError || this.isEmptyValue(params.priceChangeFrom) || this.isEmptyValue(params.priceChangeTo)) {
                    this.clearRelatedFieldError(eventId, 'priceChangeFrom');
                }

                break;

            case 'marginChangeFrom':
                hasError = false;

                if (!this.isEmptyValue(params.marginChangeFrom)) {
                    const fromValue = params.marginChangeFrom as number;

                    if (fromValue > 100) {
                        this.$set(this.autoApprovalErrors[eventId], 'marginChangeFrom', {
                            type: AutoApprovalValidationErrorType.MAX_VALUE_EXCEEDED,
                            message: this.$t('events.validation.marginLowerBoundMax') as string
                        });

                        hasError = true;
                    }
                }

                if (this.isEmptyValue(params.marginChangeFrom)) {
                    this.clearRelatedFieldError(eventId, 'marginChangeTo');
                }

                if (!hasError && !this.isEmptyValue(params.marginChangeFrom) && !this.isEmptyValue(params.marginChangeTo)) {
                    const fromValue = params.marginChangeFrom as number;
                    const toValue = params.marginChangeTo as number;

                    if (fromValue > toValue) {
                        this.$set(this.autoApprovalErrors[eventId], 'marginChangeFrom', {
                            type: AutoApprovalValidationErrorType.RANGE_INVALID,
                            message: this.$t('events.validation.lowerBoundExceedsUpper') as string,
                            relatedField: 'marginChangeTo'
                        });

                        hasError = true;
                    }
                }

                if (!hasError || this.isEmptyValue(params.marginChangeFrom) || this.isEmptyValue(params.marginChangeTo)) {
                    this.clearRelatedFieldError(eventId, 'marginChangeTo');
                }

                break;

            case 'marginChangeTo':
                hasError = false;

                if (!this.isEmptyValue(params.marginChangeTo)) {
                    const toValue = params.marginChangeTo as number;

                    if (toValue > 100) {
                        this.$set(this.autoApprovalErrors[eventId], 'marginChangeTo', {
                            type: AutoApprovalValidationErrorType.MAX_VALUE_EXCEEDED,
                            message: this.$t('events.validation.marginUpperBoundMax') as string
                        });

                        hasError = true;
                    }
                }

                if (this.isEmptyValue(params.marginChangeTo)) {
                    this.clearRelatedFieldError(eventId, 'marginChangeFrom');
                }

                if (!hasError && !this.isEmptyValue(params.marginChangeFrom) && !this.isEmptyValue(params.marginChangeTo)) {
                    const fromValue = params.marginChangeFrom as number;
                    const toValue = params.marginChangeTo as number;

                    if (fromValue > toValue) {
                        this.$set(this.autoApprovalErrors[eventId], 'marginChangeTo', {
                            type: AutoApprovalValidationErrorType.RANGE_INVALID,
                            message: this.$t('events.validation.upperBoundBelowLower') as string,
                            relatedField: 'marginChangeFrom'
                        });

                        hasError = true;
                    }
                }

                if (!hasError || this.isEmptyValue(params.marginChangeFrom) || this.isEmptyValue(params.marginChangeTo)) {
                    this.clearRelatedFieldError(eventId, 'marginChangeFrom');
                }

                break;

            case 'profitabilityFrom':
                hasError = false;

                if (!this.isEmptyValue(params.profitabilityFrom)) {
                    const fromValue = params.profitabilityFrom as number;

                    if (fromValue > 100) {
                        this.$set(this.autoApprovalErrors[eventId], 'profitabilityFrom', {
                            type: AutoApprovalValidationErrorType.MAX_VALUE_EXCEEDED,
                            message: this.$t('events.validation.profitabilityLowerBoundMax') as string
                        });

                        hasError = true;
                    }
                }

                if (this.isEmptyValue(params.profitabilityFrom)) {
                    this.clearRelatedFieldError(eventId, 'profitabilityTo');
                }

                if (!hasError && !this.isEmptyValue(params.profitabilityFrom) && !this.isEmptyValue(params.profitabilityTo)) {
                    const fromValue = params.profitabilityFrom as number;
                    const toValue = params.profitabilityTo as number;

                    if (fromValue > toValue) {
                        this.$set(this.autoApprovalErrors[eventId], 'profitabilityFrom', {
                            type: AutoApprovalValidationErrorType.RANGE_INVALID,
                            message: this.$t('events.validation.lowerBoundExceedsUpper') as string,
                            relatedField: 'profitabilityTo'
                        });

                        hasError = true;
                    }
                }

                if (!hasError || this.isEmptyValue(params.profitabilityFrom) || this.isEmptyValue(params.profitabilityTo)) {
                    this.clearRelatedFieldError(eventId, 'profitabilityTo');
                }

                break;

            case 'profitabilityTo':
                hasError = false;

                if (!this.isEmptyValue(params.profitabilityTo)) {
                    const toValue = params.profitabilityTo as number;

                    if (toValue > 100) {
                        this.$set(this.autoApprovalErrors[eventId], 'profitabilityTo', {
                            type: AutoApprovalValidationErrorType.MAX_VALUE_EXCEEDED,
                            message: this.$t('events.validation.profitabilityUpperBoundMax') as string
                        });

                        hasError = true;
                    }
                }

                if (this.isEmptyValue(params.profitabilityTo)) {
                    this.clearRelatedFieldError(eventId, 'profitabilityFrom');
                }

                if (!hasError && !this.isEmptyValue(params.profitabilityFrom) && !this.isEmptyValue(params.profitabilityTo)) {
                    const fromValue = params.profitabilityFrom as number;
                    const toValue = params.profitabilityTo as number;

                    if (fromValue > toValue) {
                        this.$set(this.autoApprovalErrors[eventId], 'profitabilityTo', {
                            type: AutoApprovalValidationErrorType.RANGE_INVALID,
                            message: this.$t('events.validation.upperBoundBelowLower') as string,
                            relatedField: 'profitabilityFrom'
                        });

                        hasError = true;
                    }
                }

                if (!hasError || this.isEmptyValue(params.profitabilityFrom) || this.isEmptyValue(params.profitabilityTo)) {
                    this.clearRelatedFieldError(eventId, 'profitabilityFrom');
                }

                break;

            case 'piFrom':
                hasError = false;

                if (!this.isEmptyValue(params.piFrom)) {
                    const fromValue = params.piFrom as number;

                    if (fromValue < 0) {
                        this.$set(this.autoApprovalErrors[eventId], 'piFrom', {
                            type: AutoApprovalValidationErrorType.MIN_VALUE_EXCEEDED,
                            message: this.$t('events.validation.piLowerBoundMin') as string
                        });

                        hasError = true;
                    }
                }

                if (this.isEmptyValue(params.piFrom)) {
                    this.clearRelatedFieldError(eventId, 'piTo');
                }

                if (!hasError && !this.isEmptyValue(params.piFrom) && !this.isEmptyValue(params.piTo)) {
                    const fromValue = params.piFrom as number;
                    const toValue = params.piTo as number;

                    if (fromValue > toValue) {
                        this.$set(this.autoApprovalErrors[eventId], 'piFrom', {
                            type: AutoApprovalValidationErrorType.RANGE_INVALID,
                            message: this.$t('events.validation.lowerBoundExceedsUpper') as string,
                            relatedField: 'piTo'
                        });

                        hasError = true;
                    }
                }

                if (!hasError || this.isEmptyValue(params.piFrom) || this.isEmptyValue(params.piTo)) {
                    this.clearRelatedFieldError(eventId, 'piTo');
                }

                break;

            case 'piTo':
                hasError = false;

                if (!this.isEmptyValue(params.piTo)) {
                    const toValue = params.piTo as number;

                    if (toValue < 0) {
                        this.$set(this.autoApprovalErrors[eventId], 'piTo', {
                            type: AutoApprovalValidationErrorType.MIN_VALUE_EXCEEDED,
                            message: this.$t('events.validation.piUpperBoundMin') as string
                        });

                        hasError = true;
                    }
                }

                if (this.isEmptyValue(params.piTo)) {
                    this.clearRelatedFieldError(eventId, 'piFrom');
                }

                if (!hasError && !this.isEmptyValue(params.piFrom) && !this.isEmptyValue(params.piTo)) {
                    const fromValue = params.piFrom as number;
                    const toValue = params.piTo as number;

                    if (fromValue > toValue) {
                        this.$set(this.autoApprovalErrors[eventId], 'piTo', {
                            type: AutoApprovalValidationErrorType.RANGE_INVALID,
                            message: this.$t('events.validation.upperBoundBelowLower') as string,
                            relatedField: 'piFrom'
                        });

                        hasError = true;
                    }
                }

                if (!hasError || this.isEmptyValue(params.piFrom) || this.isEmptyValue(params.piTo)) {
                    this.clearRelatedFieldError(eventId, 'piFrom');
                }

                break;
            }
        }

        numberFormatter = (v: any): string => FormatNumber.format(v);

        mounted() {
            this.httpLoadModuleHints('Events').then((r) => {
                this.hints = r.data
            }).catch((e) => {
            });
            this.tabs = this.$refs.mainTabs as BTabs
            if (this.$events.selectMarket.id !== -1) {
                const self = this;
                (this.$refs.groupSelectedRef as any).toggleLoading(true);
                (this.$refs.updateRegionsRef as any).toggleLoading(true);
                (this.$refs.updateSeasonsRef as any).toggleLoading(true);
                (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(true);
                (this.$refs.formatSelectedRef as any).toggleLoading(true);
                (this.$refs.clasterSelectedRef as any).toggleLoading(true);
                (this.$refs.groupOfProductRef as any).toggleLoading(true);
                (this.$refs.subcategoriesRef as any).toggleLoading(true);
                (this.$refs.productSegmentsRef as any).toggleLoading(true);
                (this.$refs.categoryStrategyRef as any).toggleLoading(true);

                this.getCategoryInfo();
                self.getRegionInfo();
                self.getFormatInfo();
                self.getBuyerSegment();
                self.getClusterInfo();
                self.loadProductsGroup();
                self.loadProductsSubcategories();
                self.loadProductSegments();
                setTimeout(() => { (this.$refs.categoryStrategyRef as any).toggleLoading(false); }, Math.floor(Math.random() * (800 - 300 + 1)) + 300);
            }
            this.$events.onlyChangedPrices = true;

            EventBus.$on('events', this.onCalcEventReceived);

            const pager = { ...this.pagination };
            pager.current = 1;
            this.pagination = pager;
            this.fetchEventList({
                isCart: false,
                currentPage: this.pagination.current
            }, () => {})
            this.startIntervalForFetchingEventsWatchingStatus()
        }

    beforeDestroy() {
        this.$calc.hintsLoaded = false
        this.$calc.currentModuleHints = []
        EventBus.$off('events', this.onCalcEventReceived);

        // Очистка таймера при уничтожении компонента
        if (this.intervalId) {
          clearInterval(this.intervalId)
        }
    }

    created() {
        this.httpLoadModuleHints('Events').then((r) => {
            this.$calc.currentModuleHints = r.data
            this.$calc.hintsLoaded = true
        }).catch((e) => {
        });
    }

    onCalcEventReceived(data: TaskData) {
        if (this.showCalcProgress(data.status)) {
        }

    }

    changeFilterValue(value: any, field: string) {
          //@ts-ignore
          this[field] = value;
    }

    refreshEventList() {
        const oldRefreshId = this.refreshEventListId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshEventListId === timeoutId) {
                this.eventCurrentPage = 1;
                const events = this.$refs.eventTableRef as any;
                if (typeof events !== 'undefined') {
                    events.$forceUpdate();
                }
                this.refreshEventListId = -1;
            }
        }, 250);
        this.refreshEventListId = timeoutId;
    }

        refreshEventListBySelectedFilters() {
            if (this.currentTab == 'cartsEvents') {
                this.fetchEventList({
                    isCart: true,
                    currentPage: this.pagination.current
                }, () => {})
            } else {
                this.fetchEventList({
                    isCart: false,
                    currentPage: this.pagination.current
                }, () => {})
            }
        }

        disableEventsCheckbox(): boolean {
          return this.startingWatchEvents
              || this.startingWatchEventsKvi
              || this.isEventsWatchingStatusInProgress
        }

        disableForceStartWatchingEventsButton(): boolean {
          return this.startingWatchEvents
              || this.startingWatchEventsKvi
              || this.isEventsWatchingStatusInProgress
              || !this.anyEventsSelected()
        }

        getSelectedEventsCount(): number {
          if (this.allRowsSelected) {
            return this.totalElements - this.excluded.length
          } else {
            return this.included.length
          }
        }

        forceStartWatchingEvents() {
          this.startingWatchEvents = true
          const params: ManuallyEventsWatchingParams = {
            allRowsSelected: this.allRowsSelected,
            included: this.included,
            excluded: this.excluded
          }
          this.httpStartWatchingEventsSimpleManually(params)
              .then(() => {
                this.showInfo(this.$t('events.messages.scanEventsStarted') as string)
                this.startIntervalForFetchingEventsWatchingStatus()
              })
              .finally(() => {
                this.startingWatchEvents = false
              })
        }

        forceStartWatchingEventsKvi() {
          this.startingWatchEventsKvi = true
          const params: ManuallyEventsWatchingParams = {
            allRowsSelected: this.allRowsSelected,
            included: this.included,
            excluded: this.excluded
          }
          this.httpStartWatchingEventsKviManually(params)
              .then(() => {
                this.showInfo(this.$t('events.messages.scanCartEventsStarted') as string)
                this.startIntervalForFetchingEventsWatchingStatus()
              })
              .finally(() => {
                this.startingWatchEventsKvi = false
              })
        }

        setStartDate(row: ScheduleCalcColumns): string | null {
            return row.startDate
        }

        isSelectRecalculation(events: EventFilter): boolean {
            return events.startCalculation;
        }

        isSelectChangedPrices(events: EventFilter): boolean {
            return events.onlyChangedPrices;
        }

        isSelectDeployPrices(events: EventFilter): boolean {
            return events.deployPrices;
        }

        isSelectCreateCommonReport(events: EventFilter): boolean {
            return events.createCommonReport;
        }

        resetModalData(type: TaskInfoFilterType) {
            switch (type) {
                case TaskInfoFilterType.all:
                    // Reset all form data values
                    this.eventDetailsFormData.groupsOfProduct = [];
                    this.eventDetailsFormData.categoriesOfProduct = [];
                    this.eventDetailsFormData.subcategories = [];
                    this.eventDetailsFormData.separateSubcategories = false;
                    this.eventDetailsFormData.productSegments = [];
                    this.eventDetailsFormData.formatSelected = [];
                    this.eventDetailsFormData.regionSelected = [];
                    this.eventDetailsFormData.clusterSelected = [];
                    this.eventDetailsFormData.separateClusters = false;
                    this.eventDetailsFormData.buyerSegmentsList = [];
                    this.eventDetailsFormData.seasonSelected = [];
                    this.eventDetailsFormData.categoryStrategy = null;

                    // Reset all options
                    this.modalTaskInfo.groupsOfProduct = [];
                    this.modalTaskInfo.categoryOptions = [];
                    this.modalTaskInfo.subcategories = [];
                    this.modalTaskInfo.psegemnts = [];
                    this.modalTaskInfo.storeFormatOptions = [];
                    this.modalTaskInfo.storeRegionOptions = [];
                    this.modalTaskInfo.clusterOptions = [];
                    this.modalTaskInfo.buyerSegmentOptions = [];
                    (this.modalTaskInfo as any).seasonList = [];

                    // Reload all data
                    this.loadModalProductsGroup(this.selectedEvent.tradingId);
                    this.getModalCategoryInfo(this.selectedEvent.tradingId);
                    this.loadModalProductsSubcategories(this.selectedEvent.tradingId);
                    this.loadModalProductSegments(this.selectedEvent.tradingId);
                    this.getModalFormatInfo(this.selectedEvent.tradingId);
                    this.getModalRegionInfo(this.selectedEvent.tradingId);
                    this.getModalClusterInfo(this.selectedEvent.tradingId);
                    this.getModalBuyerSegment(this.selectedEvent.tradingId);
                    break;

                case TaskInfoFilterType.group:
                    // Reset form data values
                    this.eventDetailsFormData.categoriesOfProduct = [];
                    this.eventDetailsFormData.subcategories = [];
                    this.eventDetailsFormData.productSegments = [];
                    this.eventDetailsFormData.formatSelected = [];
                    this.eventDetailsFormData.regionSelected = [];
                    this.eventDetailsFormData.clusterSelected = [];

                    // Reset options
                    this.modalTaskInfo.categoryOptions = [];
                    this.modalTaskInfo.subcategories = [];
                    this.modalTaskInfo.psegemnts = [];
                    this.modalTaskInfo.storeFormatOptions = [];
                    this.modalTaskInfo.storeRegionOptions = [];
                    this.modalTaskInfo.clusterOptions = [];

                    this.getModalCategoryInfo(this.selectedEvent.tradingId);
                    this.loadModalProductsSubcategories(this.selectedEvent.tradingId);
                    this.loadModalProductSegments(this.selectedEvent.tradingId);
                    this.getModalFormatInfo(this.selectedEvent.tradingId);
                    this.getModalRegionInfo(this.selectedEvent.tradingId);
                    this.getModalClusterInfo(this.selectedEvent.tradingId);
                    break;
                case TaskInfoFilterType.category:
                    // Reset form data values
                    this.eventDetailsFormData.subcategories = [];
                    this.eventDetailsFormData.productSegments = [];
                    this.eventDetailsFormData.formatSelected = [];
                    this.eventDetailsFormData.regionSelected = [];
                    this.eventDetailsFormData.clusterSelected = [];

                    // Reset options
                    this.modalTaskInfo.subcategories = [];
                    this.modalTaskInfo.psegemnts = [];
                    this.modalTaskInfo.storeFormatOptions = [];
                    this.modalTaskInfo.storeRegionOptions = [];
                    this.modalTaskInfo.clusterOptions = [];

                    this.loadModalProductsSubcategories(this.selectedEvent.tradingId);
                    this.loadModalProductSegments(this.selectedEvent.tradingId);
                    this.getModalFormatInfo(this.selectedEvent.tradingId);
                    this.getModalRegionInfo(this.selectedEvent.tradingId);
                    this.getModalClusterInfo(this.selectedEvent.tradingId);
                    break;
                case TaskInfoFilterType.subcategory:
                    // Reset form data values
                    this.eventDetailsFormData.productSegments = [];
                    this.eventDetailsFormData.formatSelected = [];
                    this.eventDetailsFormData.regionSelected = [];
                    this.eventDetailsFormData.clusterSelected = [];

                    // Reset options
                    this.modalTaskInfo.psegemnts = [];
                    this.modalTaskInfo.storeFormatOptions = [];
                    this.modalTaskInfo.storeRegionOptions = [];
                    this.modalTaskInfo.clusterOptions = [];

                    this.loadModalProductSegments(this.selectedEvent.tradingId);
                    this.getModalFormatInfo(this.selectedEvent.tradingId);
                    this.getModalRegionInfo(this.selectedEvent.tradingId);
                    this.getModalClusterInfo(this.selectedEvent.tradingId);
                    break;
                case TaskInfoFilterType.p_segemnt:
                    // Reset form data values
                    this.eventDetailsFormData.formatSelected = [];
                    this.eventDetailsFormData.regionSelected = [];
                    this.eventDetailsFormData.clusterSelected = [];

                    // Reset options
                    this.modalTaskInfo.storeFormatOptions = [];
                    this.modalTaskInfo.storeRegionOptions = [];
                    this.modalTaskInfo.clusterOptions = [];

                    this.getModalFormatInfo(this.selectedEvent.tradingId);
                    this.getModalRegionInfo(this.selectedEvent.tradingId);
                    this.getModalClusterInfo(this.selectedEvent.tradingId);
                    break;
                case TaskInfoFilterType.format:
                    // Reset form data values
                    this.eventDetailsFormData.regionSelected = [];
                    this.eventDetailsFormData.clusterSelected = [];

                    // Reset options
                    this.modalTaskInfo.storeRegionOptions = [];
                    this.modalTaskInfo.clusterOptions = [];

                    this.loadModalProductSegments(this.selectedEvent.tradingId);
                    this.getModalRegionInfo(this.selectedEvent.tradingId);
                    this.getModalClusterInfo(this.selectedEvent.tradingId);
                    break;
                case TaskInfoFilterType.region:
                    // Reset form data values
                    this.eventDetailsFormData.clusterSelected = [];

                    // Reset options
                    this.modalTaskInfo.clusterOptions = [];

                    this.loadModalProductSegments(this.selectedEvent.tradingId);
                    this.getModalClusterInfo(this.selectedEvent.tradingId);
                    break;
            }
        }
        resetData(type: TaskInfoFilterType) {
            switch (type) {
                case TaskInfoFilterType.group:
                    this.$events.categoriesOfProduct = [];
                    this.$events.subcategories = this.defaultIntSelectBox.map(i => i.value);
                    this.$events.formatSelected = this.defaultIntSelectBox.map(i => i.value);
                    this.$events.productSegments = this.defaultIntSelectBox.map(i => i.value);
                    this.$events.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                    this.$events.clusterSelected = this.defaultIntSelectBox.map(i => i.value);

                    this.taskInfo.categoryOptions = [];
                    this.taskInfo.subcategories = [];
                    this.taskInfo.psegemnts = [];
                    this.taskInfo.storeFormatOptions = [];
                    this.taskInfo.storeRegionOptions = [];
                    this.taskInfo.clusterOptions = [];

                    this.getCategoryInfo(null);
                    this.loadProductsSubcategories();
                    this.loadProductSegments();
                    this.getFormatInfo();
                    this.getRegionInfo();
                    this.getClusterInfo();
                    break;
                case TaskInfoFilterType.category:
                    this.$events.subcategories = this.defaultIntSelectBox.map(i => i.value);
                    this.$events.formatSelected = this.defaultIntSelectBox.map(i => i.value);
                    this.$events.productSegments = this.defaultIntSelectBox.map(i => i.value);
                    this.$events.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                    this.$events.clusterSelected = this.defaultIntSelectBox.map(i => i.value);

                    this.taskInfo.subcategories = [];
                    this.taskInfo.psegemnts = [];
                    this.taskInfo.storeFormatOptions = [];
                    this.taskInfo.storeRegionOptions = [];
                    this.taskInfo.clusterOptions = [];

                    this.loadProductsSubcategories();
                    this.loadProductSegments();
                    this.getFormatInfo();
                    this.getRegionInfo();
                    this.getClusterInfo();
                    break;
                case TaskInfoFilterType.subcategory:
                    this.$events.formatSelected = this.defaultIntSelectBox.map(i => i.value);
                    this.$events.productSegments = this.defaultIntSelectBox.map(i => i.value);
                    this.$events.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                    this.$events.clusterSelected = this.defaultIntSelectBox.map(i => i.value);

                    this.taskInfo.psegemnts = [];
                    this.taskInfo.storeFormatOptions = [];
                    this.taskInfo.storeRegionOptions = [];
                    this.taskInfo.clusterOptions = [];

                    this.loadProductSegments();
                    this.getFormatInfo();
                    this.getRegionInfo();
                    this.getClusterInfo();
                    break;
                case TaskInfoFilterType.p_segemnt:
                    this.$events.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                    this.taskInfo.storeFormatOptions = [];
                    this.taskInfo.storeRegionOptions = [];
                    this.taskInfo.clusterOptions = [];
                    this.getFormatInfo();
                    this.getRegionInfo();
                    this.getClusterInfo();
                    break;
                case TaskInfoFilterType.format:
                    this.$events.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                    this.$events.clusterSelected = this.defaultIntSelectBox.map(i => i.value);

                    this.taskInfo.storeRegionOptions = [];
                    this.taskInfo.clusterOptions = [];

                    this.loadProductSegments();
                    this.getRegionInfo();
                    this.getClusterInfo();
                    break;
                case TaskInfoFilterType.region:
                    this.$events.clusterSelected = this.defaultIntSelectBox.map(i => i.value);
                    this.taskInfo.clusterOptions = [];

                    this.loadProductSegments();
                    this.getClusterInfo();
                    break;
            }
        }

        updateProductGroup(groupOfProduct: number[]) {
            if (groupOfProduct.length > 0 && !LocalData.compareTwoArrays(groupOfProduct, this.$events.groupsOfProduct)) {
                this.$events.groupsOfProduct = groupOfProduct;
                this.saveEvents();
                this.resetData(TaskInfoFilterType.group);
            } else if (this.$events.groupsOfProduct[0] === 0) {
                this.$events.groupsOfProduct = this.defaultIntSelectBox.map((i) => i.value);
            }
        }

        updateProductCategory(categories: number[]) {
            if (categories.length > 0 && !LocalData.compareTwoArrays(categories, this.$events.categoriesOfProduct)) {
                this.$events.categoriesOfProduct = categories;
                this.resetData(TaskInfoFilterType.category);
                this.saveEvents();
            } else if (this.$events.categoriesOfProduct[0] === 0) {
                this.$events.categoriesOfProduct = this.defaultIntSelectBox.map((i) => i.value);
            }
        }

        updateFormats(list: number[]) {
            if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$events.formatSelected)) {
                this.$events.formatSelected = list;
                this.resetData(TaskInfoFilterType.format);
                this.saveEvents();
            } else if (this.$events.formatSelected[0] === 0) {
                this.$events.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
            }
        }

        handleCartEventsLevelFilterUpdated(value: number | number[], filterName: keyof ICartEventsLevelFilterValues) {
            if (Array.isArray(value)) {
                if (value.length > 0 && !LocalData.compareTwoArrays(value, this.cartEventsLevelFilterValues[filterName] as number[])) {
                    this.cartEventsLevelFilterValues[filterName] = value;
                } else if (value[0] === 0) {
                    this.cartEventsLevelFilterValues[filterName] = this.defaultIntSelectBox.map((i) => i.value);
                }
            } else {
                if (!!value !== this.cartEventsLevelFilterValues[filterName]) {
                    this.cartEventsLevelFilterValues[filterName] = value;
                } else if (value === 0) {
                    this.cartEventsLevelFilterValues[filterName] = this.defaultIntSelectBox[0].value;
                }
            }

            this.resetCartEventsLevelFilters(filterName);
        }

        updateRegions(list: number[]) {
            if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$events.regionSelected)) {
                this.$events.regionSelected = list;
                this.resetData(TaskInfoFilterType.region);
                this.saveEvents();
            } else if (this.$events.regionSelected[0] === 0) {
                this.$events.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
            }
        }

        updateClusters(list: number[]) {
            if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$events.clusterSelected)) {
                this.$events.clusterSelected = list;
                this.resetData(TaskInfoFilterType.cluster);
                this.saveEvents();
            } else if (this.$events.clusterSelected[0] === 0) {
                this.$events.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
            }
        }

        updateBuyerSegments(list: number[]) {
            if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$events.buyerSegmentsList)) {
                this.$events.buyerSegmentsList = list;
                this.saveEvents();
            } else if (this.$events.buyerSegmentsList[0] === 0) {
                this.$events.buyerSegmentsList = this.defaultIntSelectBox.map((i) => i.value);
            }
        }

        updateSubcategories(list: number[]) {
            if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$events.subcategories)) {
                this.$events.subcategories = list;
                this.saveEvents();
                this.resetData(TaskInfoFilterType.subcategory);
            } else if (this.$events.subcategories[0] === 0) {
            this.$events.subcategories = this.defaultIntSelectBox.map(i => i.value);
        }
    }

    updateProductSegment(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$events.productSegments)) {
            this.$events.productSegments = list;
            this.saveEvents();
            this.resetData(TaskInfoFilterType.p_segemnt);
        } else if (this.$events.productSegments[0] === 0) {
            this.$events.productSegments = this.defaultIntSelectBox.map(i => i.value);
            }
        }

        updateSeasons(list: number[]) {
            if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$events.seasonSelected)) {
                this.$events.seasonSelected = list;
                this.saveEvents();
            } else if (this.$events.seasonSelected[0] === 0) {
                this.$events.seasonSelected = this.defaultIntSelectBox.map((i) => i.value);
            }
        }

        updateSelectMarket(market: SelectMarket) {
            if (this.$events.selectMarket == null || this.$events.selectMarket.id !== market.id) {
                this.kviCartComponentKey += 1
                this.resetEventsData();
                this.$events.selectMarket = market;
                this.initTask();
                // this.initModalTask();
                this.saveEvents();
            }
        }

        loadKviCarts() {
            if (this.$events.selectMarket.id != null && this.$events.selectMarket.id !== -1) {
                this.httpLoadKviCartsByTradingId(this.$events.selectMarket.id)
                    .then((json) => {
                        this.kviCarts = json.data
                            .sort((a, b) => {
                                return a.id === b.id ? 0 : +(a.id > b.id) || -1;
                            });
                        this.kviCarts.map((it) => this.kviCartNameOptions.push(
                            {value: it.id, label: it.kviCartName}
                        ));
                    })
                    .catch((err) => {});
            }
        }

        showCalcProgress(status: string): boolean {
            return (status === 'WriteToFileComplete'
                    || status === 'EmptyData'
                    || status === 'ExecutionException'
                    || status.includes('Error'));
        }

        selectData(): [number[], number[], number[], number[]] {
            const selectSeasons: number[] = (this.$events.seasonSelected.length === 0 || (this.$events.seasonSelected.length === 1 && this.$events.seasonSelected[0] === 0))
                    ? []
                    // tslint:disable-next-line: no-non-null-assertion
                    : LocalData.filterNumberArrays(this.$events.seasonSelected)!!;
            const selectRegions: number[] = (this.$events.regionSelected.length === 0 || (this.$events.regionSelected.length && this.$events.regionSelected[0] === 0))
                    ? []
                    // tslint:disable-next-line: no-non-null-assertion
                    : LocalData.filterNumberArrays(this.$events.regionSelected)!!;
            const selectBuyerSegment: number[] = (this.$events.buyerSegmentsList.length === 0 || (this.$events.buyerSegmentsList.length && this.$events.buyerSegmentsList[0] === 0))
                    ? []
                    // tslint:disable-next-line: no-non-null-assertion
                    : LocalData.filterNumberArrays(this.$events.buyerSegmentsList)!!;
            const selectFormats: number[] = (this.$events.formatSelected.length === 0 || (this.$events.formatSelected.length && this.$events.formatSelected[0] === 0))
                    ? []
                    // tslint:disable-next-line: no-non-null-assertion
                    : LocalData.filterNumberArrays(this.$events.formatSelected)!!;
            return [selectSeasons, selectRegions, selectBuyerSegment, selectFormats];
        }

        initTask() {
            if (this.$events.selectMarket.id === -1) {
                return;
            }
            (this.$refs.updateRegionsRef as any).toggleLoading(true);
            (this.$refs.updateSeasonsRef as any).toggleLoading(true);
            (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(true);
            (this.$refs.formatSelectedRef as any).toggleLoading(true);
            (this.$refs.groupSelectedRef as any).toggleLoading(true);
            (this.$refs.clasterSelectedRef as any).toggleLoading(true);
            (this.$refs.groupOfProductRef as any).toggleLoading(true);
            (this.$refs.subcategoriesRef as any).toggleLoading(true);
        (this.$refs.productSegmentsRef as any).toggleLoading(true);

            this.$events.categoriesOfProduct = [];
            this.$events.clusterSelected = [];
            this.$events.formatSelected = [];
            this.$events.groupsOfProduct = [];
            this.$events.subcategories = [];
        this.$events.productSegments = [];
            this.taskInfo.storeFormatOptions = [];
            this.taskInfo.storeRegionOptions = [];
            this.taskInfo.buyerSegmentOptions = [];
            this.taskInfo.categoryOptions = [];
            this.taskInfo.clusterOptions = [];
            this.taskInfo.psegemnts = [];
            this.taskInfo.subcategories = [];
            this.taskInfo.groupsOfProduct = [{value: null, label: this.$t('shared.selectBox.all') as string}];
            const self = this;
            this.getCategoryInfo(() => {
                self.loadProductsGroup();
                self.getRegionInfo();
                self.getFormatInfo();
                self.getBuyerSegment();
                self.getClusterInfo();
                self.loadProductsSubcategories();
                self.loadProductSegments();
            });
        }

        initModalTask(eventTradingId: number) {
            this.modalTaskInfo.storeFormatOptions = [];
            this.modalTaskInfo.storeRegionOptions = [];
            this.modalTaskInfo.buyerSegmentOptions = [];
            this.modalTaskInfo.categoryOptions = [];
            this.modalTaskInfo.clusterOptions = [];
            this.modalTaskInfo.psegemnts = [];
            this.modalTaskInfo.subcategories = [];
            this.modalTaskInfo.groupsOfProduct = [{value: null, label: this.$t('shared.selectBox.all') as string}];
            this.getModalCategoryInfo(eventTradingId)
                .then(() => Promise.all([
                  this.loadModalProductsGroup(eventTradingId),
                  this.getModalRegionInfo(eventTradingId),
                  this.getModalFormatInfo(eventTradingId),
                  this.getModalBuyerSegment(eventTradingId),
                  this.getModalClusterInfo(eventTradingId),
                  this.loadModalProductsSubcategories(eventTradingId),
                  this.loadModalProductSegments(eventTradingId)
                ]))
                .then(() => {
                  const selectedEvent = this.selectedEvent
                  // все данные загружены
                  this.fillModalFormValues(selectedEvent.id);
                })
                .catch((e) => {
                  this.showError(this.$t('shared.messages.errorLoadingData') as string);
                });
        }

        saveCartEvent() {
            if (this.$events.selectMarket.id <= 0) {
                this.showError(this.$t('shared.messages.tradingCompanyNotSelected') as string);
                return;
            }
            const eventParams = this.getFiltersForSaveCartEvent();
            this.httpLoadEventsCheckIdentical(eventParams)
                .then((r) => {
                        if (r.data.ids.length > 0) {
                            this.showAction(
                                this.$t('events.messages.eventOverwriteConfirm') as string,
                                {
                                    position: 'top-center',
                                    type: 'info',
                                    singleton: true,
                                    duration: 10000,
                                    icon: 'check',
                                    theme: 'bubble',
                                    action: [{
                                        text: this.$t('shared.buttons.yes') as string,
                                        onClick: () => {
                                            this.httpUpdateEvent(eventParams, r.data.ids[0])
                                                .then(() => {
                                                        this.showInfo(this.$t('events.messages.eventOverwritten') as string);
                                                        this.needLoadFiltersForTable = true;
                                                        this.fetchEventList({
                                                            isCart: true,
                                                            currentPage: this.pagination.current
                                                        }, () => {});
                                                        this.refreshEventList();
                                                    },
                                                )
                                                .catch((ex) => {
                                                    this.showError(this.$t('events.messages.errorOverwriteEvent') as string);
                                                });
                                        },
                                    }],
                                });
                        } else {
                            this.httpCreateEvent(eventParams)
                                .then(() => {
                                        this.showInfo(this.$t('events.messages.eventCreated') as string);
                                        this.fetchEventList({
                                            isCart: true,
                                            currentPage: this.pagination.current
                                        }, () => {});
                                    },
                                )
                                .catch((ex) => {
                                    this.showError(this.$t('events.messages.errorCreateEvent') as string);
                                });
                        }
                    },
                )
                .catch((e) => {
                    console.log(e);
                    this.showError(this.$t('events.messages.eventAlreadyExists') as string);
                });
        }

        loadModalProductsGroup(eventTradingId: number) {
            return this.httpGetProductInfo(this.getModalTaskInfo(TaskInfoFilterType.group, eventTradingId))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.modalGroupOfProductRef as any).toggleLoading(false);
                        }, 250);
                        this.modalTaskInfo.groupsOfProduct = filterData.groups.map((i) => {
                            return {value: i.id, label: i.name}
                        });
                        this.modalTaskInfo.groupsOfProduct.unshift({value: 0, label: this.$t('shared.selectBox.all') as string});
                    })
                    .catch((e) => {
                    })
        }

        loadProductsGroup() {
          return this.httpGetProductInfo(
              this.getTaskInfo(TaskInfoFilterType.group)
          )
              .then((data) => {
                  const filterData = data.data;
                  setTimeout(() => {
                      (this.$refs.groupOfProductRef as any).toggleLoading(false);
                  }, 250);
                  this.taskInfo.groupsOfProduct = filterData.groups.map((i) => {
                      return {value: i.id, label: i.name}
                  });
                  this.taskInfo.groupsOfProduct.unshift({value: 0, label: this.$t('shared.selectBox.all') as string});
              })
              .catch((e) => {
                this.showError(this.$t('events.messages.errorLoadProductGroups') as string);
                throw e;
              })
        }

        loadModalProductsSubcategories(eventTradingId: number) {
            return this.httpGetProductInfo(this.getModalTaskInfo(TaskInfoFilterType.subcategory, eventTradingId))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.subcategoriesRef as any).toggleLoading(false);
                        }, 250);
                        this.modalTaskInfo.subcategories = filterData.subcategories.map((i) => {
                            return {value: i.id, label: i.name}
                        });
                        this.modalTaskInfo.subcategories.unshift({value: 0, label: this.$t('shared.selectBox.all') as string})
                    })
                    .catch((e) => {
                    })
        }

        loadProductsSubcategories() {
            this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.subcategoriesRef as any).toggleLoading(false);
                        }, 250);
                        this.taskInfo.subcategories = filterData.subcategories.map((i) => {
                            return {value: i.id, label: i.name}
                        });
                        this.taskInfo.subcategories.unshift({value: 0, label: this.$t('shared.selectBox.all') as string})
                    })
                    .catch((e) => {
                    })
        }

        getModalCategoryInfo(eventTradingId: number) {
            return this.httpGetProductInfo(this.getModalTaskInfo(TaskInfoFilterType.category, eventTradingId))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.modalGroupSelectedRef as any).toggleLoading(false);
                            (this.$refs.modalUpdateSeasonsRef as any).toggleLoading(false);
                        }, 250);
                        this.modalTaskInfo.categoryOptions = filterData.categories.map((i) => {
                            return {value: i.id, label: i.name}
                        });
                        this.modalTaskInfo.categoryOptions.unshift();
                    })
                    .catch((e) => {
                    })
        }

        getCategoryInfo(cb: any = null, eventTradingId?: number) {
            this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category, eventTradingId))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.groupSelectedRef as any).toggleLoading(false);
                            (this.$refs.updateSeasonsRef as any).toggleLoading(false);
                        }, 250);
                        this.taskInfo.categoryOptions = filterData.categories.map((i) => {
                            return {value: i.id, label: i.name}
                        });
                        this.taskInfo.categoryOptions.unshift();
                        if (typeof cb === 'function') {
                            cb();
                        }
                    })
                    .catch((e) => {
                    })
        }

        getModalRegionInfo(eventTradingId: number) {
            return this.httpGetProductInfo(this.getModalTaskInfo(TaskInfoFilterType.region, eventTradingId))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.updateRegionsRef as any).toggleLoading(false);

                        }, 500);

                        this.modalTaskInfo.storeRegionOptions = filterData.storeRegion.map((i) => {
                            return {value: i.id, label: i.name};
                        });
                    })
                    .catch((e) => {
                    });
        }

        getRegionInfo() {
            this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.updateRegionsRef as any).toggleLoading(false);

                        }, 500);

                        this.taskInfo.storeRegionOptions = filterData.storeRegion.map((i) => {
                            return {value: i.id, label: i.name};
                        });
                    })
                    .catch((e) => {
                    });
        }

        getModalFormatInfo(eventTradingId: number) {
            return this.httpGetProductInfo(this.getModalTaskInfo(TaskInfoFilterType.format, eventTradingId))
                    .then((data) => {
                        const filterData = data.data;
                        console.log("filterData.storeFormat", filterData.storeFormat);
                        setTimeout(() => {
                            (this.$refs.formatSelectedRef as any).toggleLoading(false);
                        }, 500);
                        this.modalTaskInfo.storeFormatOptions = filterData.storeFormat.map((i) => {
                            return {value: i.id, label: i.name};
                        });

                    })
                    .catch((e) => {
                    });
        }
        getFormatInfo() {
            this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.formatSelectedRef as any).toggleLoading(false);
                        }, 500);
                        this.taskInfo.storeFormatOptions = filterData.storeFormat.map((i) => {
                            return {value: i.id, label: i.name};
                        });

                    })
                    .catch((e) => {
                    });
        }

        getModalBuyerSegment(eventTradingId: number) {
            return this.httpGetProductInfo(this.getModalTaskInfo(TaskInfoFilterType.buyer, eventTradingId))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(false);
                        }, 500);

                        this.modalTaskInfo.buyerSegmentOptions = filterData.buyerSegments.map((i) => {
                            return {value: i.id, label: i.name};
                        });

                    })
                    .catch((e) => {
                    });
        }
        getBuyerSegment() {
            this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.buyer))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(false);
                        }, 500);

                        this.taskInfo.buyerSegmentOptions = filterData.buyerSegments.map((i) => {
                            return {value: i.id, label: i.name};
                        });

                    })
                    .catch((e) => {
                    });
        }

        getModalClusterInfo(eventTradingId: number) {
            return this.httpGetProductInfo(this.getModalTaskInfo(TaskInfoFilterType.cluster, eventTradingId))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.clasterSelectedRef as any).toggleLoading(false);
                        }, 500);

                        this.modalTaskInfo.clusterOptions = filterData.storeCluster.map((i) => {
                            return {value: i.id, label: i.name};
                        });
                    })
                    .catch((e) => {
                    });
        }

        getClusterInfo() {
            this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
                    .then((data) => {
                        const filterData = data.data;
                        setTimeout(() => {
                            (this.$refs.clasterSelectedRef as any).toggleLoading(false);
                        }, 500);

                        this.taskInfo.clusterOptions = filterData.storeCluster.map((i) => {
                            return {value: i.id, label: i.name};
                        });
                    })
                    .catch((e) => {
                    });
        }

        loadModalProductSegments(eventTradingId: number) {
            return this.httpGetProductInfo(this.getModalTaskInfo(TaskInfoFilterType.p_segemnt, eventTradingId))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.productSegmentsRef as any).toggleLoading(false);
                    }, 250);
                    this.modalTaskInfo.psegemnts = filterData.psegments.map((i) => {
                        return {
                            label: i.name,
                            value: i.id,
                        }
                    });
                    this.modalTaskInfo.psegemnts.unshift({ value: 0, label: this.$t('shared.selectBox.all') as string });
                })
                .catch((e) => {
                });
        }

        loadProductSegments() {
            this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.p_segemnt))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.productSegmentsRef as any).toggleLoading(false);
                    }, 250);
                    this.taskInfo.psegemnts = filterData.psegments.map((i) => {
                        return {
                            label: i.name,
                            value: i.id,
                        }
                    });
                    this.taskInfo.psegemnts.unshift({ value: 0, label: this.$t('shared.selectBox.all') as string });
                })
                .catch((e) => {
                });
        }

        saveEditableEvent(id: number, event: SmallEventFilter, changingType: LoadEventChangingType,
                          periodicity: LoadEventPeriods, type: LoadEventType) {
            // If this is saving from the modal, validate the form first
            if (this.eventDetailsModalVisible && !this.validateEventDetailsForm()) {
                return;
            }

            // If this is coming from the modal, apply the form data
            if (this.eventDetailsModalVisible) {
                this.applyEventDetailsFormData();
                // Close the modal
                this.eventDetailsModalVisible = false;
            }

            this.savingEventId = id;
            const updateEvent = this.toEventIndividConfig(event, changingType, periodicity, type)
            this.httpSaveEvents(id, updateEvent)
                    .then((r) => {
                                this.showInfo(this.$t('events.messages.eventParamsSaved') as string);
                                this.refreshEventList()
                                this.savingEventId = null;
                            },
                    )
                    .catch((e) => {
                        this.showError(this.$t('events.messages.errorSaveParams') as string);
                        this.savingEventId = null;
                    });
        }

        toEventIndividConfig(event: SmallEventFilter, newChangingType: LoadEventChangingType,
                             newPeriodicity: LoadEventPeriods, newType: LoadEventType): EventIndividualConfigs {
            // Convert arrays to string for API compatibility
            const processedEvent = {...event};

            // Convert groupsOfProduct array to string if it's an array
            if (Array.isArray(processedEvent.groupsOfProduct)) {
                processedEvent.groupsOfProduct = processedEvent.groupsOfProduct
                    .map((item: any) => item.label || item.value || item)
                    .join(', ');
            }

            // Convert categoriesOfProduct array to string if it's an array
            if (Array.isArray(processedEvent.categoriesOfProduct)) {
                processedEvent.categoriesOfProduct = processedEvent.categoriesOfProduct
                    .map((item: any) => item.label || item.value || item)
                    .join(', ');
            }

            // Convert subcategories array to string if it's an array
            if (Array.isArray(processedEvent.subcategories)) {
                processedEvent.subcategories = processedEvent.subcategories
                    .map((item: any) => item.label || item.value || item)
                    .join(', ');
            }

            // Convert formatSelected array to string if it's an array
            if (Array.isArray(processedEvent.formatSelected)) {
                processedEvent.formatSelected = processedEvent.formatSelected
                    .map((item: any) => item.label || item.value || item)
                    .join(', ');
            }

            // Convert regionSelected array to string if it's an array
            if (Array.isArray(processedEvent.regionSelected)) {
                processedEvent.regionSelected = processedEvent.regionSelected
                    .map((item: any) => item.label || item.value || item)
                    .join(', ');
            }

            // Convert clusterSelected array to string if it's an array
            if (Array.isArray(processedEvent.clusterSelected)) {
                processedEvent.clusterSelected = processedEvent.clusterSelected
                    .map((item: any) => item.label || item.value || item)
                    .join(', ');
            }

            // Map frontend field names to backend field names for API compatibility
            const storeFormat = processedEvent.formatSelected;
            const storeRegions = processedEvent.regionSelected;
            const storeCluster = processedEvent.clusterSelected;
            const categories = processedEvent.categoriesOfProduct;

            return {
                startDate: processedEvent.startDate,
                endDate: processedEvent.endDate,
                delta: processedEvent.delta,
                startCalculation: processedEvent.startCalculation,
                onlyChangedPrices: processedEvent.onlyChangedPrices,
                deployPrices: processedEvent.deployPrices,
                createCommonReport: processedEvent.createCommonReport,
                changingType: newChangingType,
                type: newType,
                periodicity: newPeriodicity,
                priority: processedEvent.priority,
                timeout: processedEvent.timeout,
                separateClusters: processedEvent.separateClusters,
                separateSubcategories: processedEvent.separateSubcategories,
                applyOmnichannel: processedEvent.applyOmnichannel,
                kviCartId: processedEvent.kviCartId,
                kviCartName: processedEvent.kviCartName,
                autoApprovalParams: processedEvent.autoApprovalParams && processedEvent.autoApprovalParams.useAutoApproval ? {
                    useAutoApproval: processedEvent.autoApprovalParams.useAutoApproval,
                    priceChangeFrom: processedEvent.autoApprovalParams.priceChangeFrom,
                    priceChangeTo: processedEvent.autoApprovalParams.priceChangeTo,
                    marginChangeFrom: processedEvent.autoApprovalParams.marginChangeFrom,
                    marginChangeTo: processedEvent.autoApprovalParams.marginChangeTo,
                    profitabilityFrom: processedEvent.autoApprovalParams.profitabilityFrom,
                    profitabilityTo: processedEvent.autoApprovalParams.profitabilityTo,
                    piFrom: processedEvent.autoApprovalParams.piFrom,
                    piTo: processedEvent.autoApprovalParams.piTo,
                    revaluationEfficiencyCheck: processedEvent.autoApprovalParams.revaluationEfficiencyCheck || false,
                } : undefined,
            }
        }

        deleteEvent(eventId: number) {
            this.deletingEventId = eventId;
            this.httpDeleteEvent(eventId)
                    .then((r) => {
                                this.showInfo(this.$t('events.messages.eventDeleted') as string);
                                this.fetchEventList({
                                    isCart: false,
                                    currentPage: this.pagination.current
                                }, () => {});
                            },
                    )
                    .catch((e) => {
                        this.showError(this.$t('events.messages.errorDeleteEvent') as string);
                    })
                    .finally(() => {
                        this.deletingEventId = null;
                    });
        }

        deleteCartEvent(eventId: number) {
            this.deletingEventId = eventId;
            this.httpDeleteEvent(eventId)
                .then((r) => {
                        this.showInfo(this.$t('events.messages.eventDeleted') as string);
                        this.fetchEventList({
                            isCart: true,
                            currentPage: this.pagination.current
                        }, () => {});
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('events.messages.errorDeleteEvent') as string);
                })
                .finally(() => {
                    this.deletingEventId = null;
                });
        }

        showEventDetails(event: any) {
            // Clone the event to avoid modifying the original
            this.selectedEvent = {...event};
            this.initModalTask(event.tradingId);

            // Map backend field names to frontend field names if needed
            if (this.selectedEvent.storeFormat && !this.selectedEvent.formatSelected) {
                this.selectedEvent.formatSelected = this.selectedEvent.storeFormat;
            }

            if (this.selectedEvent.storeRegions && !this.selectedEvent.regionSelected) {
                this.selectedEvent.regionSelected = this.selectedEvent.storeRegions;
            }

            if (this.selectedEvent.storeCluster && !this.selectedEvent.clusterSelected) {
                this.selectedEvent.clusterSelected = this.selectedEvent.storeCluster;
            }

            if (this.selectedEvent.categories && !this.selectedEvent.categoriesOfProduct) {
                this.selectedEvent.categoriesOfProduct = this.selectedEvent.categories;
            }

            // Parse string fields into arrays
            if (this.selectedEvent.groupsOfProduct && typeof this.selectedEvent.groupsOfProduct === 'string') {
                // Split the string by commas and trim whitespace
                this.selectedEvent.groupsOfProduct = this.selectedEvent.groupsOfProduct
                    .split(',')
                    .map((item: string) => item.trim())
                    .filter((item: string) => item !== '')
                    // Convert to value objects as expected by MultiSelect
                    .map((name: string) => {
                        const foundItem = this.taskInfo.groupsOfProduct.find(
                            (group: any) => group.label === name || group.value.toString() === name
                        );
                        return foundItem || { value: name, label: name };
                    });
            }

            // Similar parsing for other string fields that should be arrays
            if (this.selectedEvent.categoriesOfProduct && typeof this.selectedEvent.categoriesOfProduct === 'string') {
                this.selectedEvent.categoriesOfProduct = this.selectedEvent.categoriesOfProduct
                    .split(',')
                    .map((item: string) => item.trim())
                    .filter((item: string) => item !== '')
                    .map((name: string) => {
                        const foundItem = this.taskInfo.categoryOptions.find(
                            (cat: any) => cat.label === name || cat.value.toString() === name
                        );
                        return foundItem || { value: name, label: name };
                    });
            }

            if (this.selectedEvent.subcategories && typeof this.selectedEvent.subcategories === 'string') {
                this.selectedEvent.subcategories = this.selectedEvent.subcategories
                    .split(',')
                    .map((item: string) => item.trim())
                    .filter((item: string) => item !== '')
                    .map((name: string) => {
                        const foundItem = this.taskInfo.subcategories.find(
                            (sub: any) => sub.label === name || sub.value.toString() === name
                        );
                        return foundItem || { value: name, label: name };
                    });
            }

            if (this.selectedEvent.formatSelected && typeof this.selectedEvent.formatSelected === 'string') {
                this.selectedEvent.formatSelected = this.selectedEvent.formatSelected
                    .split(',')
                    .map((item: string) => item.trim())
                    .filter((item: string) => item !== '')
                    .map((name: string) => {
                        const foundItem = this.taskInfo.storeFormatOptions.find(
                            (format: any) => format.label === name || format.value.toString() === name
                        );
                        return foundItem || { value: name, label: name };
                    });
            }

            if (this.selectedEvent.regionSelected && typeof this.selectedEvent.regionSelected === 'string') {
                this.selectedEvent.regionSelected = this.selectedEvent.regionSelected
                    .split(',')
                    .map((item: string) => item.trim())
                    .filter((item: string) => item !== '')
                    .map((name: string) => {
                        const foundItem = this.taskInfo.storeRegionOptions.find(
                            (region: any) => region.label === name || region.value.toString() === name
                        );
                        return foundItem || { value: name, label: name };
                    });
            }

            if (this.selectedEvent.clusterSelected && typeof this.selectedEvent.clusterSelected === 'string') {
                this.selectedEvent.clusterSelected = this.selectedEvent.clusterSelected
                    .split(',')
                    .map((item: string) => item.trim())
                    .filter((item: string) => item !== '')
                    .map((name: string) => {
                        const foundItem = this.taskInfo.clusterOptions.find(
                            (cluster: any) => cluster.label === name || cluster.value.toString() === name
                        );
                        return foundItem || { value: name, label: name };
                    });
            }

            // Initialize the event details form data
            this.initializeEventDetailsFormData(this.selectedEvent);

            this.eventDetailsModalVisible = true;
        }

        /**
         * Initialize the event details form data with values from the selected event
         * @param event The event to use for initialization
         */
        initializeEventDetailsFormData(event: any) {
            // Start with either the event's values or empty values
            const initialData = {
                groupsOfProduct: event.groupsOfProduct || [],
                categoriesOfProduct: event.categoriesOfProduct || [],
                subcategories: event.subcategories || [],
                separateSubcategories: event.separateSubcategories || false,
                categoryStrategy: event.categoryStrategy || null,
                productSegments: event.productSegments || [],
                formatSelected: event.formatSelected || [],
                regionSelected: event.regionSelected || [],
                clusterSelected: event.clusterSelected || [],
                separateClusters: event.separateClusters || false,
                buyerSegmentsList: event.buyerSegmentsList || [],
                seasonSelected: event.seasonSelected || []
            };

            // Process string arrays if needed
            this.processStringArrays(initialData);

            // Set the form data
            this.eventDetailsFormData = initialData;
            
            // Set the original data as a deep copy for change tracking
            this.originalEventDetailsFormData = _.cloneDeep(initialData);
        }

        /**
         * Process string arrays in the form data
         * @param formData The form data to process
         */
        processStringArrays(formData: any) {
            // Process groups of product
            if (formData.groupsOfProduct && typeof formData.groupsOfProduct === 'string') {
                formData.groupsOfProduct = this.parseStringToArray(
                    formData.groupsOfProduct,
                    this.taskInfo.groupsOfProduct
                );
            }

            // Process categories of product
            if (formData.categoriesOfProduct && typeof formData.categoriesOfProduct === 'string') {
                formData.categoriesOfProduct = this.parseStringToArray(
                    formData.categoriesOfProduct,
                    this.taskInfo.categoryOptions
                );
            }

            // Process subcategories
            if (formData.subcategories && typeof formData.subcategories === 'string') {
                formData.subcategories = this.parseStringToArray(
                    formData.subcategories,
                    this.taskInfo.subcategories
                );
            }

            // Process product segments
            if (formData.productSegments && typeof formData.productSegments === 'string') {
                formData.productSegments = this.parseStringToArray(
                    formData.productSegments,
                    this.taskInfo.psegemnts
                );
            }

            // Process format selected
            if (formData.formatSelected && typeof formData.formatSelected === 'string') {
                formData.formatSelected = this.parseStringToArray(
                    formData.formatSelected,
                    this.taskInfo.storeFormatOptions
                );
            }

            // Process region selected
            if (formData.regionSelected && typeof formData.regionSelected === 'string') {
                formData.regionSelected = this.parseStringToArray(
                    formData.regionSelected,
                    this.taskInfo.storeRegionOptions
                );
            }

            // Process cluster selected
            if (formData.clusterSelected && typeof formData.clusterSelected === 'string') {
                formData.clusterSelected = this.parseStringToArray(
                    formData.clusterSelected,
                    this.taskInfo.clusterOptions
                );
            }

            // Process buyer segments list
            if (formData.buyerSegmentsList && typeof formData.buyerSegmentsList === 'string') {
                formData.buyerSegmentsList = this.parseStringToArray(
                    formData.buyerSegmentsList,
                    this.taskInfo.buyerSegmentOptions
                );
            }

            // Process season selected
            if (formData.seasonSelected && typeof formData.seasonSelected === 'string') {
                formData.seasonSelected = this.parseStringToArray(
                    formData.seasonSelected,
                    this.seasonList
                );
            }
        }

        /**
         * Parse a string to an array of objects
         * @param str The string to parse
         * @param options The options to match against
         * @returns An array of objects with value and label properties
         */
        parseStringToArray(str: string, options: Array<any>): Array<any> {
            return str
                .split(',')
                .map((item: string) => item.trim())
                .filter((item: string) => item !== '')
                .map((name: string) => {
                    const foundItem = options.find(
                        (option: any) => option.label === name || option.value.toString() === name
                    );
                    return foundItem || { value: name, label: name };
                });
        }

        /**
         * Validate the event details form data
         * @returns True if the form data is valid, false otherwise
         */
        validateEventDetailsForm(): boolean {
            // Add validation rules as needed
            if (!this.eventDetailsFormData.groupsOfProduct || this.eventDetailsFormData.groupsOfProduct.length === 0) {
                this.showError(this.$t('events.messages.selectProductGroup') as string);
                return false;
            }

            return true;
        }

        /**
         * Apply the event details form data to the selected event
         */
        applyEventDetailsFormData() {
            if (!this.selectedEvent) return;

            // Apply all form fields to the selected event
            this.selectedEvent = {
                ...this.selectedEvent,
                groupsOfProduct: this.eventDetailsFormData.groupsOfProduct,
                categoriesOfProduct: this.eventDetailsFormData.categoriesOfProduct,
                subcategories: this.eventDetailsFormData.subcategories,
                separateSubcategories: this.eventDetailsFormData.separateSubcategories,
                categoryStrategy: this.eventDetailsFormData.categoryStrategy,
                productSegments: this.eventDetailsFormData.productSegments,
                formatSelected: this.eventDetailsFormData.formatSelected,
                regionSelected: this.eventDetailsFormData.regionSelected,
                clusterSelected: this.eventDetailsFormData.clusterSelected,
                separateClusters: this.eventDetailsFormData.separateClusters,
                buyerSegmentsList: this.eventDetailsFormData.buyerSegmentsList,
                seasonSelected: this.eventDetailsFormData.seasonSelected
            };
        }

        /**
         * Save an event from the modal form
         */
        saveEventFromModal() {
          if (!this.selectedEvent) return;

          // Validate the form
          if (!this.validateEventDetailsForm()) {
              return;
          }

          const eventParams = this.buildUpdateLoadEventDto()

          this.httpLoadEventsCheckIdentical(eventParams)
              .then((r) => {
                    if (r.data.ids.length > 0) {
                      this.showAction(
                          this.$t('events.messages.eventCategoryExists') as string,
                          {
                            position: 'top-center',
                            type: 'info',
                            singleton: true,
                            duration: 10000,
                            icon: 'check',
                            theme: 'bubble',
                            action: [{
                              text: this.$t('shared.actions.ok') as string
                            }],
                          });
                    } else {
                      const eventId = this.selectedEvent.id
                      this.httpUpdateEventFilterParams(eventParams, eventId)
                          .then(() => {
                                this.showInfo(this.$t('events.messages.eventSaved') as string);
                                // Reset change tracking after successful save
                                this.eventDetailsModalVisible = false
                                this.fetchEventList({
                                  currentPage: this.pagination.current
                                }, () => {});
                              },
                          )
                          .catch((ex) => {
                            this.showError(this.$t('events.messages.errorEditEventNomenclature') as string);
                          })
                    }
                  },
              )
              .catch((e) => {
                this.showError(this.$t('events.messages.errorCheckIdenticalEvent') as string);
              });
        }

  private fillModalFormValues(eventId: number): any {
    this.httpGetEditEventSelections(eventId)
        .then((response) => {
          const eventData = response.data
          this.eventDetailsFormData.formatSelected = eventData.storeFormats.map(this.toSelectBox);
          this.eventDetailsFormData.categoriesOfProduct = eventData.categories.map(this.toSelectBox);
          this.eventDetailsFormData.regionSelected = eventData.storeRegions.map(this.toSelectBox);
          this.eventDetailsFormData.groupsOfProduct = eventData.groups.map(this.toSelectBox);
          this.eventDetailsFormData.buyerSegmentsList = eventData.buyerSegments.map(this.toSelectBox);
          this.eventDetailsFormData.clusterSelected = eventData.storeClusters.map(this.toSelectBox);
          this.eventDetailsFormData.productSegments = eventData.psegments.map(this.toSelectBox);
          this.eventDetailsFormData.subcategories = eventData.subcategories.map(this.toSelectBox);
          this.eventDetailsFormData.separateSubcategories = eventData.separateSubcategories;
          this.eventDetailsFormData.categoryStrategy = eventData.categoryStrategy;
          this.eventDetailsFormData.separateClusters = eventData.separateClusters;
          // Handle seasonSelected if it exists in the response
          if (eventData.seasonSelected) {
            this.eventDetailsFormData.seasonSelected = eventData.seasonSelected.map(this.toSelectBox);
          } else {
            this.eventDetailsFormData.seasonSelected = [];
          }
        })
        .catch((error) => {
          console.error('Error loading event selections:', error);
          this.showError(this.$t('events.messages.errorLoadEventData') as string);
        })
        .finally(() => {
          // After loading all data, set the original form data for change tracking
          // Create a deep copy to prevent reference issues
          this.originalEventDetailsFormData = _.cloneDeep(this.eventDetailsFormData);
          this.hasUnsavedModalChanges = false; // Reset unsaved changes flag
        });
  }

  private toSelectBox(tag: ProductTag) {
    return tag.id;
  }

  private buildUpdateLoadEventDto(): EventFilter {
    const selected = this.selectedEvent;
    const form = this.eventDetailsFormData;

    return {
      type: selected.type.value,
      tradingId: selected.tradingId,
      startDate: selected.startDate,
      endDate: selected.endDate,
      delta: selected.delta,
      startCalculation: selected.startCalculation,
      onlyChangedPrices: selected.onlyChangedPrices,
      deployPrices: selected.deployPrices,
      createCommonReport: selected.createCommonReport,
      changingType: selected.changingType.value,
      periodicity: selected.periodicity.value,
      priority: selected.priority,
      timeout: selected.timeout,
      applyOmnichannel: selected.applyOmnichannel,
      kviCartId: selected.kviCartId,
      kviCartName: selected.kviCartName,
      autoApprovalParams: selected.autoApprovalParams && selected.autoApprovalParams.useAutoApproval ? selected.autoApprovalParams : undefined,

      groupsOfProduct: form.groupsOfProduct || [],
      categories: form.categoriesOfProduct || [],
      subcategories: form.subcategories || [],
      storeFormat: form.formatSelected || [],
      storeRegionValues: form.regionSelected || [],
      storeCluster: form.clusterSelected || [],
      productSegments: form.productSegments || [],
      buyerSegments: form.buyerSegmentsList || [],
      categoryStrategy: form.categoryStrategy ? form.categoryStrategy.value : CategoryStrategies.EMPTY,
      separateSubcategories: form.separateSubcategories,
      separateClusters: form.separateClusters,
    };
  }

        resetEventDetailsModalData() {
            // Reset the selected event and form data
            // console.log('afterClose');
            this.selectedEvent = null;
            this.originalEventDetailsFormData = null;

            // Use the 'all' case to reset all fields at once
            this.resetModalData(TaskInfoFilterType.all);

            // Reset any additional fields or UI components that might not be covered
            this.$nextTick(() => {
                // Reset any component references if needed
                if (this.$refs.modalGroupOfProductRef) (this.$refs.modalGroupOfProductRef as any).resetSelected();
                if (this.$refs.modalGroupSelectedRef) (this.$refs.modalGroupSelectedRef as any).resetSelected();
                if (this.$refs.modalSubcategoriesRef) (this.$refs.modalSubcategoriesRef as any).resetSelected();
                if (this.$refs.modalProductSegmentsRef) (this.$refs.modalProductSegmentsRef as any).resetSelected();
                if (this.$refs.modalFormatSelectedRef) (this.$refs.modalFormatSelectedRef as any).resetSelected();
                if (this.$refs.modalUpdateRegionsRef) (this.$refs.modalUpdateRegionsRef as any).resetSelected();
                if (this.$refs.modalClasterSelectedRef) (this.$refs.modalClasterSelectedRef as any).resetSelected();
                if (this.$refs.modalUpdateBuyerSegmentsRef) (this.$refs.modalUpdateBuyerSegmentsRef as any).resetSelected();
                if (this.$refs.modalUpdateSeasonsRef) (this.$refs.modalUpdateSeasonsRef as any).resetSelected();
            });

            // Handle any custom fields that aren't part of the TaskInfoCalc interface
            (this.modalTaskInfo as any).seasonList = [];

            // Call base reset method for TaskInfoFilterType.group
            this.resetModalData(TaskInfoFilterType.group);
            
        }

        /**
         * Handle changes in the event details form
         */
        handleEventDetailsFormChange() {
            // This method is called when any value in the event details form changes

            // Check if there are changes by comparing current form data with original
            this.checkForUnsavedChanges();

            // Perform real-time validation as needed
            this.validateFormFieldDependencies();

            // Log form data changes (can be removed in production)
            // console.log('Event details form data updated:', this.eventDetailsFormData);
        }

        /**
         * Check if the current form data differs from the original data
         */
        checkForUnsavedChanges() {
            if (!this.originalEventDetailsFormData || 
                (this.originalEventDetailsFormData && this.originalEventDetailsFormData.length === 0)) {
                this.hasUnsavedModalChanges = false;
                this.isCheckingForUnsavedChanges = false;
                return;
            }
            
            // Set loading state to true
            this.isCheckingForUnsavedChanges = true;
            this.hasUnsavedModalChanges = false; // Don't show notification until check is complete
            
            setTimeout(() => {
                // Deep compare the current form data with the original using Lodash
                const hasChanges = !_.isEqual(this.eventDetailsFormData, this.originalEventDetailsFormData);
                this.hasUnsavedModalChanges = hasChanges;
                this.isCheckingForUnsavedChanges = false; // Loading complete
            }, 300);
        }        
        /**
         * Validate form field dependencies to ensure consistent state ( resets dependent fields if parent selection is cleared )
         */
        validateFormFieldDependencies() {
            // Reset dependent fields when parent selection changes

            // If no groups are selected, clear categories
            if (!this.isEventDetailsGroupsSelected && this.eventDetailsFormData.categoriesOfProduct.length > 0) {
                this.eventDetailsFormData.categoriesOfProduct = [];
            }

            // If no categories are selected, clear subcategories
            if (!this.isEventDetailsCategoriesSelected && this.eventDetailsFormData.subcategories.length > 0) {
                this.eventDetailsFormData.subcategories = [];
            }

            // If no subcategories are selected, clear product segments
            if (!this.isEventDetailsSubcategorySelected && this.eventDetailsFormData.productSegments.length > 0) {
                this.eventDetailsFormData.productSegments = [];
            }

            // If no formats are selected, clear regions
            if (!this.isEventDetailsFormatSelected && this.eventDetailsFormData.regionSelected.length > 0) {
                this.eventDetailsFormData.regionSelected = [];
            }

            // If no regions are selected, clear clusters
            if (!this.isEventDetailsRegionsSelected && this.eventDetailsFormData.clusterSelected.length > 0) {
                this.eventDetailsFormData.clusterSelected = [];
            }
        }

        clearEventFilters() {
            this.newSelectTradingFilter = this.defaultFilterValue.value;
            this.traidingsFilterOptions = []
            this.newSelectCategoryFilter = this.defaultFilterValue.value;
            this.categoryFilterOptions = []
            this.newSelectGroupFilter = this.defaultFilterValue.value;
            this.groupFilterOptions = []
            this.newSelectSubcategoryFilter = this.defaultFilterValue.value;
            this.subcategoryFilterOptions = []
            this.newSelectFormatFilter = this.defaultFilterValue.value;
            this.formatFilterOptions = []
            this.newSelectRegionFilter = this.defaultFilterValue.value;
            this.regionFilterOptions = []
            this.newSelectClusterFilter = this.defaultFilterValue.value;
            this.kviCartNameOptions = []
            this.newKviCartNameFilter = this.defaultFilterValue.value;
            this.clusterFilterOptions = []
            this.needLoadFiltersForTable = true;

            if (this.currentTab == 'cartsEvents') {
                this.fetchEventList({
                    isCart: true,
                    currentPage: this.pagination.current
                }, () => {})
            } else {
                this.fetchEventList({
                    isCart: false,
                    currentPage: this.pagination.current
                }, () => {})
            }
        }

        onEventTableChange(pagination: any) {
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.resetEventsSelectedData()
            this.fetchEventList({
                isCart: false,
                currentPage: pagination.current
            }, () => {});
        }

        onCartsEventTableChange(pagination: any) {
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.resetEventsSelectedData()
            this.fetchEventList({
                isCart: true,
                currentPage: pagination.current
            }, () => {});
            console.log(this.eventTableRows.length)
        }

        saveCategoryEvent() {
            if (this.$events.selectMarket.id <= 0) {
                this.showError(this.$t('shared.messages.tradingCompanyNotSelected') as string);
                return;
            }

            this.isCreatingEvent = true;
            const eventParams = this.getFiltersForSaveCategoryEvent();
            this.httpLoadEventsCheckIdentical(eventParams)
                    .then((r) => {
                                if (r.data.ids.length > 0) {
                                    this.showAction(
                                            this.$t('events.messages.eventCategoryOverwriteConfirm') as string,
                                            {
                                                position: 'top-center',
                                                type: 'info',
                                                singleton: true,
                                                duration: 10000,
                                                icon: 'check',
                                                theme: 'bubble',
                                                action: [{
                                                    text: this.$t('shared.buttons.yes') as string,
                                                    onClick: () => {
                                                        this.httpUpdateEvent(eventParams, r.data.ids[0])
                                                                .then(() => {
                                                                            this.showInfo(this.$t('events.messages.eventSaved') as string);
                                                                            this.needLoadFiltersForTable = true;
                                                                            this.fetchEventList({
                                                                                    currentPage: this.pagination.current
                                                                                }, () => {});
                                                                            this.refreshEventList();
                                                                        },
                                                                )
                                                                .catch((ex) => {
                                                                    this.showError(this.$t('events.messages.errorSaveEvent') as string);
                                                                })
                                                                .finally(() => {
                                                                    this.isCreatingEvent = false;
                                                                });
                                                    },
                                                }],
                                            });
                                } else {
                                    this.httpCreateEvent(eventParams)
                                            .then(() => {
                                                        this.showInfo(this.$t('events.messages.eventSaved') as string);
                                                        this.fetchEventList({
                                                            currentPage: this.pagination.current
                                                        }, () => {});
                                                    },
                                            )
                                            .catch((ex) => {
                                                this.showError(this.$t('events.messages.errorSaveEvent') as string);
                                            })
                                            .finally(() => {
                                                this.isCreatingEvent = false;
                                            });
                                }
                            },
                    )
                    .catch((e) => {
                      console.log(e);
                        this.showError(this.$t('events.messages.errorSaveEvent') as string);
                    })
                    .finally(() => {
                        // Set to false in case the action dialog wasn't shown
                        if (this.isCreatingEvent) {
                            this.isCreatingEvent = false;
                        }
                    });
        }

        fetchEventList(ctx: any, callback: (items: any[]) => void) {
            const filter = this.getSmallEventFilter()
            const offset = (ctx.currentPage - 1) * this.eventCalcLimit;
            const watchEventsType: WatchEventsType = ctx.isCart ? WatchEventsType.KVI_EVENT : WatchEventsType.SIMPLE_EVENT
            const requestFilter = this.getRequestEventFilter(filter, watchEventsType, this.eventCalcLimit, offset)
            this.tableIsLoading = true
            this.httpGetSavedEvents(requestFilter)
                    .then((r) => {
                                this.eventTableRows = r.data.content;
                                this.totalElements = r.data.totalElements
                                if (ctx.isCart) {
                                    this.eventTableRows = this.eventTableRows.filter((it) => it.kviCartId !== undefined)
                                } else {
                                    this.eventTableRows = this.eventTableRows.filter((it) => it.kviCartId === undefined)
                                }
                                this.eventTableRows.forEach((column) => {
                                    column.periodicity = this.eventPeriodicityOpts.find((e) => {
                                        return e.value === column.periodicity;
                                    }) as unknown as LoadEventPeriods;

                                    column.changingType = this.eventChangingTypeOpts.find((e) => {
                                        return e.value === column.changingType;
                                    }) as unknown as LoadEventChangingType

                                    column.type = this.eventTypeOpts.find((e) => {
                                        return e.value === column.type;
                                    }) as unknown as LoadEventType

                                    column.startDate = moment(new Date(column.startDate)).format('YYYY-MM-DD')
                                    column.endDate = moment(new Date(column.endDate)).format('YYYY-MM-DD')
                                });

                                if (this.needLoadFiltersForTable) {
                                    this.httpGetAllFiltersInEventList(this.currentTab)
                                            .then((response) => {
                                                        const result = response.data

                                                        this.traidingsFilterOptions = result.tradingName.map((i) => {
                                                            return {value: i.id, label: i.name};
                                                        });

                                                        const categories = result.categories.filter((i) => {
                                                            return i.name !== '';
                                                        });
                                                        this.categoryFilterOptions = categories.map((i) => {
                                                            return {value: i.id, label: i.name};
                                                        });
                                                        const groups = result.groupsOfProduct.filter((i) => {
                                                            return i.name !== '';
                                                        });
                                                        this.groupFilterOptions = groups.map((i) => {
                                                            return {value: i.id, label: i.name};
                                                        });
                                                        const subcategories = result.subcategories.filter((i) => {
                                                            return i.name !== '';
                                                        });
                                                        this.subcategoryFilterOptions = subcategories.map((i) => {
                                                            return {value: i.id, label: i.name};
                                                        });
                                                        const storeFormat = result.storeFormat.filter((i) => {
                                                            return i.name !== '';
                                                        });
                                                        this.formatFilterOptions = storeFormat.map((i) => {
                                                            return {value: i.id, label: i.name};
                                                        });
                                                        const regions = result.storeRegionValues.filter((i) => {
                                                            return i.name !== '';
                                                        });
                                                        this.regionFilterOptions = regions.map((i) => {
                                                            return {value: i.id, label: i.name};
                                                        });
                                                        const clusters = result.storeCluster.filter((i) => {
                                                            return i.name !== '';
                                                        });
                                                        this.clusterFilterOptions = clusters.map((i) => {
                                                            return {value: i.id, label: i.name};
                                                        });
                                                        const kviCarts = result.kviCart.filter((i) => {
                                                            return i.name !== '';
                                                        });
                                                        this.kviCartNameOptions = kviCarts.map((i) => {
                                                            return {value: i.id, label: i.name};
                                                        });

                                                        this.traidingsFilterOptions.unshift(this.defaultFilterValue);
                                                        this.categoryFilterOptions.unshift(this.defaultFilterValue);
                                                        this.groupFilterOptions.unshift(this.defaultFilterValue);
                                                        this.subcategoryFilterOptions.unshift(this.defaultFilterValue);
                                                        this.formatFilterOptions.unshift(this.defaultFilterValue);
                                                        this.regionFilterOptions.unshift(this.defaultFilterValue);
                                                        this.clusterFilterOptions.unshift(this.defaultFilterValue);
                                                        this.kviCartNameOptions.unshift(this.defaultFilterValue);

                                                        this.needLoadFiltersForTable = false;
                                                    },
                                            )
                                            .catch((ex) => {
                                                this.showError(this.$t('events.messages.errorLoadEventFilters') as string);
                                            });
                                 }

                                const pagination = { ...this.pagination };
                                pagination.total = r.data.totalElements;
                                this.pagination = pagination;

                                this.eventTotalRows = r.data.totalElements;
                                callback(r.data.content);
                            })
                    .catch((e) => {
                        callback([]);
                    })
                    .finally(() => {
                      this.tableIsLoading = false
                    });
        }


        timeoutPriorityDeltaValidate(n: number): boolean {
            return n > 0;
        }

    onMultiSelectToggle(open: boolean) {
        this.dropDownOpen = open;
        if (!open) {
            if (this.onDropdownClosed != null) {
                this.onDropdownClosed.apply(open);
                this.onDropdownClosed = null;
            }
        }
    }

        private getModalTaskInfo(taskType: TaskInfoFilterType, eventTradingId: number): GetTaskInfo {
            // Use event details form data instead of main component data
            const eventData = this.eventDetailsFormData;

            // Get the selected values from modal data
            const selectRegions = eventData && eventData.regionSelected ?
                LocalData.filterNumberArrays(eventData.regionSelected) : [];
            const selectFormats = eventData && eventData.formatSelected ?
                LocalData.filterNumberArrays(eventData.formatSelected) : [];

            return {
                type: taskType,
                tradingId: eventTradingId,
                categories: eventData ? LocalData.filterNumberArrays(eventData.categoriesOfProduct) : [],
                groups: eventData ? LocalData.filterNumberArrays(eventData.groupsOfProduct) : [],
                subcategory: eventData ? LocalData.filterNumberArrays(eventData.subcategories, true) : [],
                productSegments: eventData ? LocalData.filterNumberArrays(eventData.productSegments) : [],
                segments: null,
                storeFormat: selectFormats,
                storeCluster: eventData ? LocalData.filterNumberArrays(eventData.clusterSelected) : [],
                storeRegion: selectRegions,
                byReports: false,
            }
        }
        private getTaskInfo(taskType: TaskInfoFilterType, eventTradingId?: number): GetTaskInfo {
            const [, selectRegions, , selectFormats] = this.selectData();
            return {
                type: taskType,
                tradingId: eventTradingId !== undefined ? eventTradingId : this.$events.selectMarket.id,
                categories: LocalData.filterNumberArrays(this.$events.categoriesOfProduct),
                groups: LocalData.filterNumberArrays(this.$events.groupsOfProduct),
                subcategory: LocalData.filterNumberArrays(this.$events.subcategories, true),
                productSegments: LocalData.filterNumberArrays(this.$events.productSegments),
                segments: null,
                storeFormat: selectFormats,
                storeCluster: this.$events.clusterSelected,
                storeRegion: selectRegions,
                byReports: false,
            }
        }

        private getFiltersForSaveCategoryEvent(): EventFilter {
            const [, selectRegions, , selectFormats] = this.selectData();
            const selectClusters: number[] = (this.$events.clusterSelected.length === 0 || (this.$events.clusterSelected.length && this.$events.clusterSelected[0] === 0))
                    // tslint:disable-next-line: no-non-null-assertion
                    ? [] : LocalData.filterNumberArrays(this.$events.clusterSelected)!!;
            return {
                subcategories: LocalData.filterNumberArrays(this.$events.subcategories),
// tslint:disable-next-line: no-non-null-assertion
                groupsOfProduct: LocalData.filterNumberArrays(this.$events.groupsOfProduct)!!,
                storeRegionValues: selectRegions,
                storeFormat: selectFormats,
                storeCluster: selectClusters,
                categoryStrategy: this.$events.categoryStrategy.value,
                productSegments: LocalData.filterNumberArrays(this.$events.productSegments),
// tslint:disable-next-line: no-non-null-assertion
                categories: LocalData.filterNumberArrays(this.$events.categoriesOfProduct)!!,
                tradingId: this.$events.selectMarket.id,
                separateClusters: this.$events.separateClusters,
                separateSubcategories: this.$events.separateSubcategories,
                startDate: this.startDate,
                endDate: this.endDate,
                periodicity: this.selectPeriodicityOptions.value,
                priority: this.$events.priority,
                timeout: this.$events.timeout,
                delta: this.delta || 0,
                startCalculation: this.$events.startCalculation,
                onlyChangedPrices: this.$events.onlyChangedPrices,
                deployPrices: this.$events.deployPrices,
                createCommonReport: this.$events.createCommonReport,
                changingType: this.changingType.value,
                type: this.selectTypeOptions.value,
                applyOmnichannel: this.$events.applyOmnichannel,
                kviCartId: null,
                kviCartName: null,
                autoApprovalParams: this.$events.autoApprovalParams && this.$events.autoApprovalParams.useAutoApproval ? this.$events.autoApprovalParams : undefined,
            };
        }

        fetchCartEventsFormatOptions() {
            (this.$refs.cartEventsFormatFilterRef as any).toggleLoading(true);

            this.httpGetProductInfo({
                type: TaskInfoFilterType.format,
                tradingId: this.$events.selectMarket.id,
                categories: [],
                groups: [],
                subcategory: null,
                productSegments: [],
                segments: null,
                storeFormat: [],
                storeCluster: [],
                storeRegion: [],
                byReports: false,
            })
                .then((data) => {
                    const content = data.data;

                    setTimeout(() => {
                        (this.$refs.cartEventsFormatFilterRef as any).toggleLoading(false);
                    }, 500);

                    this.cartEventsLevelFilterOptions.storeFormatOptions = [
                        {value: 0, label: this.$t('shared.selectBox.all') as string},
                        ...content.storeFormat.map((i) => { return {value: i.id, label: i.name} }),
                    ];
                })
        }

        fetchCartEventsRegionOptions() {
            (this.$refs.cartEventsRegionFilterRef as any).toggleLoading(true);

            this.httpGetProductInfo({
                type: TaskInfoFilterType.region,
                tradingId: this.$events.selectMarket.id,
                categories: [],
                groups: [],
                subcategory: null,
                productSegments: [],
                segments: null,
                storeFormat: [this.cartEventsLevelFilterValues.format],
                storeCluster: [],
                storeRegion: [],
                byReports: false,
            })
                .then((data) => {
                    const content = data.data;

                    setTimeout(() => {
                        (this.$refs.cartEventsRegionFilterRef as any).toggleLoading(false);
                    }, 500);

                    this.cartEventsLevelFilterOptions.storeRegionOptions = [
                        {value: 0, label: this.$t('shared.selectBox.all') as string},
                        ...content.storeRegion.map((i) => { return {value: i.id, label: i.name} }),
                    ];
                })
        }

        fetchCartEventsClusterOptions() {
            (this.$refs.cartEventsClusterFilterRef as any).toggleLoading(true);

            this.httpGetProductInfo({
                type: TaskInfoFilterType.cluster,
                tradingId: this.$events.selectMarket.id,
                categories: [],
                groups: [],
                subcategory: null,
                productSegments: [],
                segments: null,
                storeFormat: [this.cartEventsLevelFilterValues.format],
                storeCluster: [],
                storeRegion: [this.cartEventsLevelFilterValues.region],
                byReports: false,
            })
                .then((data) => {
                    const content = data.data;

                    setTimeout(() => {
                        (this.$refs.cartEventsClusterFilterRef as any).toggleLoading(false);
                    }, 500);

                    this.cartEventsLevelFilterOptions.clusterOptions = [
                        {value: 0, label: this.$t('shared.selectBox.all') as string},
                        ...content.storeCluster.map((i) => { return {value: i.id, label: i.name} }),
                    ];
                })
        }

        resetCartEventsLevelFilters(changedFilter: string) {
            if (changedFilter === 'format') {
                this.cartEventsLevelFilterOptions.storeRegionOptions = [{value: 0, label: this.$t('shared.selectBox.all') as string}];
                this.cartEventsLevelFilterValues.region = 0;
                this.fetchCartEventsRegionOptions();

                this.cartEventsLevelFilterOptions.clusterOptions = [{value: 0, label: this.$t('shared.selectBox.all') as string}];
                this.cartEventsLevelFilterValues.clusters = [];
            } else if (changedFilter === 'region') {
                this.cartEventsLevelFilterOptions.clusterOptions = [{value: 0, label: this.$t('shared.selectBox.all') as string}];
                this.cartEventsLevelFilterValues.clusters = [];
                this.fetchCartEventsClusterOptions();
            }
        }

        private getFiltersForSaveCartEvent(): EventFilter {
            return {
                tradingId: this.$events.selectMarket.id,
                subcategories: [],
                groupsOfProduct: [],
                storeRegionValues: [this.cartEventsLevelFilterValues.region],
                storeFormat: [this.cartEventsLevelFilterValues.format],
                storeCluster: this.cartEventsLevelFilterValues.clusters.filter((value: number) => !!value),
                categoryStrategy: this.$events.categoryStrategy.value,
                productSegments: LocalData.filterNumberArrays(this.$events.productSegments),
                categories: [],
                separateClusters: this.cartEventsLevelFilterValues.separateClusters,
                separateSubcategories: false,
                kviCartId: this.$events.selectKviCart && this.$events.selectKviCart.id || null,
                kviCartName: this.$events.selectKviCart && this.$events.selectKviCart.kviCartName || null,
                // next - data from "Параметры" card
                startDate: this.startDate,
                endDate: this.endDate,
                periodicity: this.selectPeriodicityOptions.value,
                priority: this.$events.priority,
                timeout: this.$events.timeout,
                delta: this.delta || 0,
                startCalculation: this.$events.startCalculation,
                onlyChangedPrices: this.$events.onlyChangedPrices,
                deployPrices: this.$events.deployPrices,
                createCommonReport: this.$events.createCommonReport,
                changingType: this.changingType.value,
                type: this.selectTypeOptions.value,
                applyOmnichannel: this.$events.applyOmnichannel,
                autoApprovalParams: this.$events.autoApprovalParams && this.$events.autoApprovalParams.useAutoApproval ? this.$events.autoApprovalParams : undefined,
            };
        }

        private getSmallEventFilter(): SmallEventFilterTree {
            return {
                tradingId: this.newSelectTradingFilter,
                categories: this.newSelectCategoryFilter,
                groupsOfProduct: this.newSelectGroupFilter,
                subcategories: this.newSelectSubcategoryFilter,
                storeFormat: this.newSelectFormatFilter,
                storeRegions: this.newSelectRegionFilter,
                storeCluster: this.newSelectClusterFilter,
                kviCartId: this.newKviCartNameFilter == -1 ? null : this.newKviCartNameFilter,
            };
        }

        private getRequestEventFilter(filter: SmallEventFilterTree, watchEventsType: WatchEventsType, limit: number, offset: number): RequestEventList {
            return {
                tradingId: filter.tradingId,
                categories: filter.categories,
                storeCluster: filter.storeCluster,
                storeRegions: filter.storeRegions,
                storeFormat: filter.storeFormat,
                groupsOfProduct: filter.groupsOfProduct,
                subcategories: filter.subcategories,
                kviCartId: filter.kviCartId,
                watchEventsType: watchEventsType,
                limit,
                offset,
            }
        }

        private showOnlyChangedPricesConfirmWindow(isOnlyChangedPricesChecked: boolean) {
          if(!isOnlyChangedPricesChecked)
          (this.$refs.onlyChangedPricesWarningWindow as BModal).show();
        }

        get saveState(): boolean {
            // tslint:disable-next-line: no-non-null-assertion
            const filteredGroups = LocalData.filterNumberArrays(this.$events.groupsOfProduct)!!.length;
            // tslint:disable-next-line: no-non-null-assertion
            const filteredCategories = LocalData.filterNumberArrays(this.$events.categoriesOfProduct)!!.length;
            return (filteredGroups === 1 && filteredCategories === 1) || (filteredGroups === 1 && filteredCategories === 0) || (filteredGroups === 0 && filteredCategories === 1);
        }

        get isGroupsSelected(): boolean {
            const groups = LocalData.filterNumberArrays(this.$events.groupsOfProduct);
            return groups != null && groups.length > 0;
        }

        get isSubcategorySelected(): boolean {
            const subcategories = LocalData.filterNumberArrays(this.$events.subcategories);
            return subcategories != null && subcategories.length!! > 0;
        }

        get isCategoriesSelected(): boolean {
            const categories = LocalData.filterNumberArrays(this.$events.categoriesOfProduct);
            return categories != null && categories.length > 0;
        }

        get isFormatSelected(): boolean {
            const formats = LocalData.filterNumberArrays(this.$events.formatSelected);
            return formats != null && formats.length > 0;
        }

        get isRegionsSelected(): boolean {
            const regions = LocalData.filterNumberArrays(this.$events.regionSelected);
            return regions != null && regions.length > 0;
        }

        get isCreateCartEventBtnDisable() {
            return (!this.$events.selectKviCart || !this.$events.selectKviCart.id || this.$events.selectKviCart.id === -1 ) || (this.startDate == null || this.startDate === '') || (this.endDate == null || this.endDate === '');
        }

        disableParamsForEventType(type: SelectBox<LoadEventType>): boolean {
          return this.isEventTypeWithNotChangeableParams(type)
        }

        isEventTypeWithNotChangeableParams(type: SelectBox<LoadEventType>): boolean {
          return type.value == LoadEventTypeValues.CHANGING_MRP
              || type.value == LoadEventTypeValues.ADDING_NEW_PRODUCT
              || type.value == LoadEventTypeValues.CHANGING_LINES
        }

        getEventsWatchingEventsStatus() {
          this.httpGetEventsWatchingStatus()
              .then((r) => {
                this.setEventsWatchingStatus(r.data)
              })
              .finally(() => {

              })
        }

        setEventsWatchingStatus(status: EventsProcessingStatus) {
          this.eventsWatchingPreviousStatus = this.eventsWatchingStatus
          this.eventsWatchingStatus = status
          this.isEventsWatchingStatusInProgress = isInProgressStatus(status)

          const sameUpdateProcess =
              this.eventsWatchingStatus === this.eventsWatchingPreviousStatus
              && this.isEventsWatchingStatusInProgress

          // Если пришел статус updating
          if (this.isEventsWatchingStatusInProgress) {
              // Если ранее был другой статус
              if (!sameUpdateProcess) {
                // TODO: если не нужно - убрать
                // this.tableLoader.acquire()
                // this.tableLoader.message = getEventsProcessingStatusMessage(status)
              }

              return;
          }
        }
    }
